import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewChecked,
  ComponentFactoryResolver,
  Directive,
  ElementRef,
  EventEmitter,
  HostBinding,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ApplicationConfig } from '../config/config';

declare let delta: any;

@Directive({
  selector: '[ngc-calendar]',
  exportAs: 'ngc-calendar'
})
export class NgcCalendarDirective
  implements OnInit, AfterViewChecked, OnChanges, OnDestroy
{
  prevNavLinkSpan: any;
  calMobileHeadRow: any;
  calMobileFooterRow: any;
  calHorizantalRow: any;
  calFlexDateCont: any;
  calFlexDateCheckBoxLabel: any;
  calFlexDateCheckBox: any;
  calCloseButtonText: any;
  calCloseButtonCont: any;
  caldonebuttonText: any;
  caldonebuttonCont: any;
  public timeouts = [];
  @Output() calFocus = new EventEmitter<any>();
  @Output() calBlur = new EventEmitter<any>();
  @Output() calClick = new EventEmitter<any>();

  @HostBinding('class.calendarInput')
  /**
   * Pass this as as input to determine how many months to display in the calendar
   *
   * @type {number}
   * @memberof NgcCalendarDirective
   */
  @Input()
  numberOfMonthsView = 2;

  /**
   * Pass this as as input to have different date format. Possible Values can be 'mm/dd/yyyy', 'dd/mm/yyyy', 'yyyy-dd-mm'
   *
   * @type {string}
   * @memberof NgcCalendarDirective
   */
  @Input() dateFormat = 'mm/dd/yyyy';

  /**
   * Pass this as as input to determine whether to populate departure and/or return date
   *
   * @type {string}
   * @memberof NgcCalendarDirective
   */
  @Input() dataTravel = 'roundtrip';

  /**
   * Pass this as as input to determine master class to change the look and feel of the calendar.
   * Use '.calendarInput + .calendarMasterCont [or the input class name that is passed]' to manipulate the classes cased on requirement
   *
   * @type {string}
   * @memberof NgcCalendarDirective
   */
  @Input() calendarClassName = 'calendarMasterCont';

  /**
   * Pass this as as input to determine custom class to change the look and feel of the calendar.
   * Use '.calendarMasterCont &.[custom class name that is passed]' to manipulate the classes cased on requirement
   *
   * @type {string}
   * @memberof NgcCalendarDirective
   */
  @Input() calendarCustomClass = '';

  /**
   * Pass this as as input to determine departure field label text
   *
   * @type {string}
   * @memberof NgcCalendarDirective
   */
  @Input() departLabel = '';

  /**
   * Pass this as as input to determine return field label text
   *
   * @type {string}
   * @memberof NgcCalendarDirective
   */
  @Input() returnLabel = '';

  /**
   * Pass this as as input to size of the calendar. Possible values can be L, M, S, XS for Large, Medium, Small and Extra Small. Then add css accordingly.
   *
   * @type {string}
   * @memberof NgcCalendarDirective
   */
  @Input() calendarSize = 'M';

  /**
   * Pass this as as input to display the text on the field while date is not selected.
   *
   * @type {string}
   * @memberof NgcCalendarDirective
   */
  @Input() showDateFormat: string;

  /**
   * Pass this as as input to determine the number of character to be displayed for the weekdays name. For full name pass 'Full'.
   *
   * @type {*}
   * @memberof NgcCalendarDirective
   */
  @Input() numberOfWeekdayChar: any = 1;

  /**
   * Pass this as as input to determine the number of character to be displayed for the months name.  For full name pass 'Full'.
   *
   * @type {*}
   * @memberof NgcCalendarDirective
   */
  @Input() numberOfMonthChar: any = 3;

  /**
   * Pass this as as input to determine the number of days for which the calendar will be displyed.
   *
   * @type {number}
   * @memberof NgcCalendarDirective
   */
  @Input() allowDay = 331;

  @Input() allowPreviousDay: number;

  @Input() index: number;

  @Input() fieldName: string;

  @Input() calDefaultDateSeparator = 'true';

  @Input() departPlaceHolder: string;

  @Input() returnPlaceHolder: string;

  @Input() displayDateFormat: string;

  @Input() standaloneCal = 'false';

  @Input() floatingLbl: string;

  @Input() showDefaultDate: boolean;
  @Input() defaultDepartDate: string;
  @Input() defaultReturnDate: string;

  /* pass this if you want to show flex dates checkbox */
  @Input() isFlexDates = 'false';

  /* pass this if you want to show flex dates checkbox  disabled*/
  @Input() isFlexDatesDisabled = 'false';
  /* pass this if you want to show flex dates checkbox  disabled in eDoc*/
  @Input() isFlexDatesDisabledByEdoc = 'false';
  /* pass this if calendar control is first in your form to be focusable.*/
  @Input() isFirstElement = 'false';
  // tslint:disable-next-line:member-ordering
  @ViewChild(NgcCalendarDirective) componentHost: NgcCalendarDirective;
  /**
   * Pass this as as input to determine which form field to be associated to capture the date value
   *
   * @private
   * @type {UntypedFormGroup}
   * @memberof NgcCalendarDirective
   */
  // tslint:disable-next-line:no-input-rename
  @Input('formObject') private travelDateForm: UntypedFormGroup;
  /**
   * Pass this as as input to determine which form group to be associated to capture the date value
   *
   * @private
   * @type {UntypedFormGroup}
   * @memberof NgcCalendarDirective
   */
  @Input() private formObj: UntypedFormGroup;
  private nativeElement: Node;
  private parentElement: Node;
  private today = this.getSelectedDate(
    new Date().getDate(),
    new Date().getMonth() + 1,
    new Date().getFullYear(),
    this.dateFormat
  );

  private now = new Date();
  private navLink: any;
  private navLinkSpan: any;
  private calendarMasterCont: any;
  private SRInstructionCont: any;
  private calendarCont: any;
  private calPrevNextBtnCont: any;
  private calDisplayCont: any;
  private calDepartLabelCont: any;
  private calDepartSpan: any;
  private calDepartSpanLabel: any;
  private calDepartInput: any;
  private calSRDepartReturnCont: any;
  private calSRDepartReturnLabelCont: any;
  private calReturnLabelCont: any;
  private calReturnSpan: any;
  private calReturnSpanLabel: any;
  private calReturnInput: any;
  private calCancelButton: any;
  private calResetButton: any;
  private calCloseButton: any;
  private caldonebutton: any;
  private calCancelButtonCont: any;
  private calDateSeparator: any;
  private calendarWrapper: any;
  private calendarGroupWrapper: any;
  private calendarGroup: any;
  private calTableCont: any;
  private calMonth: any;
  private calYear: any;
  private calTable: any;
  private calTableBody: any;
  private weekArray = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ];

  private showWeekCharacter: any = 3;
  private todayDate = 1;
  private prevMonth = 'December';
  private currMonth = 'January';
  private nextMonth = 'February';
  private currYear = 2017;
  private currMonthIndex = 0;
  private currCalMonthIndex = 0;
  private focusableEls: any;
  private firstFocusableEl: any;
  private lastFocusableEl: any;
  private focusableDateEls: any;
  private firstFocusableDateEl: any;
  private lastFocusableDateEl: any;
  private currFocusDate = -7;
  private childEls: any;
  private dayLinkEls: any;
  private selectedDate: any;
  private presentCalYear = new Date().getFullYear();
  private last_date: any;
  private last_day: any;
  private last_month: any;
  private last_month_name: any;
  private last_year: any;
  private selectedDates: any;
  private selectedDatesBetween: any;
  private clickCounter = 0;
  private tabCounter = 0;
  private currDepartDate: any;
  private currDepartValue: any;
  private currReturnDate: any;
  private currReturnValue: any;
  private validationErrors: Array<object>;
  private viewportWidth: any;
  private previous_allowDay: any;

  /**
   * Creates an instance of NgcCalendarDirective.
   * @param {Object} platformId
   * @param {ValidationService} validationService
   * @param {ElementRef} el
   * @param {Renderer2} ren
   * @param {ComponentFactoryResolver} componentFactoryResolver
   * @param {ViewContainerRef} viewContainerRef
   * @memberof NgcCalendarDirective
   */
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private el: ElementRef,
    private ren: Renderer2,
    private config: ApplicationConfig,
    private componentFactoryResolver: ComponentFactoryResolver,
    private viewContainerRef: ViewContainerRef
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.viewportWidth = document.body.scrollWidth;
      if (this.isIE()) {
        this.viewportWidth = Math.max(
          document.documentElement.clientWidth,
          window.innerWidth || 0
        );
      }
    }
  }

  /**

   *
   * @returns {*}
   * @memberof NgcCalendarDirective
   */
  ngOnInit(): any {
    this.buildCalendar();
  }

  /**
   *
   * @returns {*}
   * @memberof NgcCalendarDirective
   */
  ngAfterViewChecked(): any {
    if (isPlatformBrowser(this.platformId)) {
      this.setDatePickerVal();
      this.checkFieldVisibility();
    }
  }

  /** set the hidden input field and datepicker display values */
  /**
   *
   *
   * @memberof NgcCalendarDirective
   */
  setDatePickerVal() {
    if (this.travelDateForm !== undefined) {
      if (this.el.nativeElement.classList.contains('validation-error')) {
        if (this.calDisplayCont.classList.contains('open')) {
          this.ren.setAttribute(
            this.calDisplayCont,
            'class',
            'validation-error calDispValueCont icon-Calendar open ' +
              (this.isFirstElement ? 'focusable-element' : ' ')
          );
        } else {
          this.ren.setAttribute(
            this.calDisplayCont,
            'class',
            'validation-error calDispValueCont icon-Calendar ' +
              (this.isFirstElement ? 'focusable-element' : ' ')
          );
        }
      } else {
        if (this.calDisplayCont.classList.contains('open')) {
          this.ren.setAttribute(
            this.calDisplayCont,
            'class',
            'calDispValueCont icon-Calendar open ' +
              (this.isFirstElement ? 'focusable-element' : ' ')
          );
        } else {
          this.ren.setAttribute(
            this.calDisplayCont,
            'class',
            'calDispValueCont icon-Calendar ' +
              (this.isFirstElement ? 'focusable-element' : ' ')
          );
        }
      }
      this.ren.setAttribute(
        this.calDisplayCont,
        'id',
        'input_departureDate_' + this.index
      );
      if (this.travelDateForm.controls['returnDate'] !== undefined) {
        if (
          this.travelDateForm.controls['departureDate'].value !== '' &&
          this.travelDateForm.controls['departureDate'].value !== undefined &&
          this.travelDateForm.controls['returnDate'].value !== 'Departure Date'
        ) {
          this.ren.setAttribute(
            this.calDisplayCont,
            'id',
            'input_returnDate_' + this.index
          );
          this.clickCounter = 1;
          let departDate = this.travelDateForm.controls['departureDate'].value;
          let currDepartDate;
          currDepartDate = departDate.split('-');
          if (currDepartDate.length > 1) {
            departDate = new Date(
              currDepartDate[1] +
                '/' +
                currDepartDate[2] +
                '/' +
                currDepartDate[0]
            );
          } else {
            departDate = new Date(
              this.travelDateForm.controls['departureDate'].value
            );
          }
          const departDD = departDate.getDate();
          const departWD = departDate.getDay() + 1;
          const departMM = departDate.getMonth() + 1;
          const departYY = departDate.getFullYear();
          departDate = this.getSelectedDate(
            departDD,
            departMM,
            departYY,
            this.dateFormat
          );
          const currdepartDate = departMM + '/' + departDD + '/' + departYY;
          const displayDepartDate = this.displayDateFormat
            ? this.getSelectedDate(
                departDD,
                departMM,
                departYY,
                this.displayDateFormat
              )
            : this.setDisplayDate(departWD, departMM, departDD);
          const SRDepartDate = this.getSRDate(
            departWD,
            departDD,
            departMM,
            departYY
          );
          this.calDepartSpan.innerText = displayDepartDate;
          this.ren.removeClass(this.calDepartSpan, 'calendar-placeholder');
          this.calDepartSpanLabel.innerText =
            this.departLabel + ' selected as ' + SRDepartDate;
          this.ren.setAttribute(this.calDepartSpan, 'aria-hidden', 'true');
          this.calDepartInput.value = departDate;
        } else {
          this.clickCounter = 0;
          this.ren.removeClass(this.calDepartSpan, 'calendar-placeholder');
          if (this.departPlaceHolder) {
            this.calDepartSpan.innerText = this.departPlaceHolder;
          } else {
            this.calDepartSpan.innerText = this.showDateFormat;
          }
          this.calDepartSpanLabel.innerText =
            this.departLabel +
            ' and ' +
            this.returnLabel +
            ' Calendar Use enter to open, escape to close the calendar, page down for next month and page up for previous month, ' +
            this.departLabel +
            ' date not selected';
          this.ren.setAttribute(this.calDepartSpan, 'aria-hidden', 'true');
          this.calDepartInput.value = '';
        }
        if (
          this.travelDateForm.controls['returnDate'].value !== '' &&
          this.travelDateForm.controls['returnDate'].value !== undefined &&
          this.travelDateForm.controls['returnDate'].value !== 'Return Date'
        ) {
          this.clickCounter = 2;
          let returnDate = this.travelDateForm.controls['returnDate'].value;
          let currReturnDate;
          currReturnDate = returnDate.split('-');
          if (currReturnDate.length > 1) {
            returnDate = new Date(
              currReturnDate[1] +
                '/' +
                currReturnDate[2] +
                '/' +
                currReturnDate[0]
            );
          } else {
            returnDate = new Date(
              this.travelDateForm.controls['returnDate'].value
            );
          }
          const returnWD = returnDate.getDay() + 1;
          const returnMM = returnDate.getMonth() + 1;
          const returnDD = returnDate.getDate();
          const returnYY = returnDate.getFullYear();
          returnDate = this.getSelectedDate(
            returnDD,
            returnMM,
            returnYY,
            this.dateFormat
          );
          const currreturnDate = returnMM + '/' + returnDD + '/' + returnYY;
          const displayReturnDate = this.displayDateFormat
            ? this.getSelectedDate(
                returnDD,
                returnMM,
                returnYY,
                this.displayDateFormat
              )
            : this.setDisplayDate(returnWD, returnMM, returnDD);
          const SRReturnDate = this.getSRDate(
            returnWD,
            returnDD,
            returnMM,
            returnYY
          );
          this.calReturnSpan.innerText = displayReturnDate;
          this.ren.removeClass(this.calReturnSpan, 'calendar-placeholder');
          this.calReturnSpanLabel.innerText = '';
          this.calDepartSpanLabel.innerText +=
            ' and ' + this.returnLabel + ' selected as ' + SRReturnDate;
          this.ren.setAttribute(this.calReturnSpan, 'aria-hidden', 'true');
          this.calReturnInput.value = returnDate;
        } else {
          if (this.returnPlaceHolder) {
            this.calReturnSpan.innerText = this.returnPlaceHolder;
          } else {
            this.calReturnSpan.innerText = this.showDateFormat;
          }
          this.ren.addClass(this.calReturnSpan, 'calendar-placeholder');
          this.calReturnSpanLabel.innerText = '';
          if (this.dataTravel === 'roundtrip') {
            this.calDepartSpanLabel.innerText +=
              ' ' + this.returnLabel + ' date not selected';
          }
          this.ren.setAttribute(this.calReturnSpan, 'aria-hidden', 'true');
          this.calReturnInput.value = '';
        }
      }
    }
  }

  /** get the current month and create anchor icon for calendar field
   *
   *
   * @memberof NgcCalendarDirective
   */
  buildCalendar() {
    if (isPlatformBrowser(this.platformId)) {
      this.nativeElement = this.el.nativeElement;
      this.parentElement = this.el.nativeElement.parentElement;
      this.getCurrentMonth();
      this.createCalendarIcon();
    }
  }

  /** Get the current month, year, previous month and next month from system
   *
   *
   * @memberof NgcCalendarDirective
   */
  getCurrentMonth() {
    const locale = 'en-us';
    this.previous_allowDay = new Date(this.today);
    this.previous_allowDay.setDate(
      this.previous_allowDay.getDate() - this.allowPreviousDay
    );
    this.todayDate = new Date().getDate();
    this.prevMonth = this.getMonthName(this.previous_allowDay.getMonth() - 1);
    this.currMonth = this.getMonthName(this.previous_allowDay.getMonth());
    this.nextMonth = this.getMonthName(this.previous_allowDay.getMonth() + 1);
    this.currCalMonthIndex = this.previous_allowDay.getMonth() + 1;
    this.currYear = this.previous_allowDay.getFullYear();
  }

  /** Returns the month names
   *
   *
   * @memberof NgcCalendarDirective
   */
  getMonthName = function (v) {
    const n = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];
    return n[v];
  };

  /** Returns the weekdays names
   *
   *
   * @memberof NgcCalendarDirective
   */
  getWeekName = function (v) {
    return this.weekArray[v];
  };

  /** Create the calendar icons and assign events to it
   *
   *
   * @memberof NgcCalendarDirective
   */
  createCalendarIcon() {
    if (this.el.nativeElement.attributes['placeholder'] !== undefined) {
      this.el.nativeElement.attributes['placeholder'].value = '';
    }
    this.ren.setAttribute(this.el.nativeElement, 'readonly', 'true');
    this.ren.setAttribute(this.el.nativeElement, 'tabindex', '-1');

    this.calendarMasterCont = this.ren.createElement('div');

    // switch-case to decide the css for the diffetent size of calendar
    switch (this.calendarSize) {
      case 'L': {
        this.ren.setAttribute(
          this.calendarMasterCont,
          'class',
          this.calendarClassName + ' ' + this.calendarCustomClass + ' calLarge'
        );
        break;
      }
      case 'M': {
        this.ren.setAttribute(
          this.calendarMasterCont,
          'class',
          this.calendarClassName + ' ' + this.calendarCustomClass + ' calMedium'
        );
        break;
      }
      case 'S': {
        this.ren.setAttribute(
          this.calendarMasterCont,
          'class',
          this.calendarClassName + ' ' + this.calendarCustomClass + ' calSmall'
        );
        break;
      }
      case 'XS': {
        this.ren.setAttribute(
          this.calendarMasterCont,
          'class',
          this.calendarClassName +
            ' ' +
            this.calendarCustomClass +
            ' calExtraSmall'
        );
        break;
      }
      default: {
        this.ren.setAttribute(
          this.calendarMasterCont,
          'class',
          this.calendarClassName + ' ' + this.calendarCustomClass
        );
        break;
      }
    }
    this.ren.appendChild(this.parentElement, this.calendarMasterCont);

    this.SRInstructionCont = this.ren.createElement('div');
    this.ren.setAttribute(
      this.SRInstructionCont,
      'class',
      'SRInstructionCont sr-only'
    );
    this.ren.setAttribute(this.SRInstructionCont, 'aria-live', 'assertive');
    this.ren.setAttribute(this.SRInstructionCont, 'role', 'status');
    this.ren.appendChild(this.calendarMasterCont, this.SRInstructionCont);

    this.calDisplayCont = this.ren.createElement('div');

    this.ren.setAttribute(
      this.calDisplayCont,
      'class',
      'calDispValueCont icon-Calendar  ' +
        (this.isFirstElement ? 'focusable-element' : ' ')
    );
    this.ren.setAttribute(this.calDisplayCont, 'tabindex', '0');
    this.ren.setAttribute(this.calDisplayCont, 'aria-expanded', 'false');
    this.ren.setAttribute(this.calDisplayCont, 'role', 'button');
    this.ren.setAttribute(this.calDisplayCont, 'aria-haspopup', 'true');
    this.ren.setAttribute(
      this.calDisplayCont,
      'aria-describedby',
      'departureDate-error' + this.index
    );
    this.ren.appendChild(this.calendarMasterCont, this.calDisplayCont);
    this.calDepartLabelCont = this.ren.createElement('span');
    this.ren.setAttribute(
      this.calDepartLabelCont,
      'class',
      'calDepartLabelCont'
    );
    this.ren.setAttribute(this.calDepartLabelCont, 'id', 'calDepartLabelCont');
    this.ren.setAttribute(
      this.calDepartLabelCont,
      'aria-label',
      'departureDate'
    );
    this.ren.appendChild(this.calDisplayCont, this.calDepartLabelCont);

    this.calDepartSpanLabel = this.ren.createElement('span');
    this.ren.setAttribute(this.calDepartSpanLabel, 'class', 'sr-only');
    this.calDepartSpanLabel.innerText = this.departLabel + ' date not selected';
    this.ren.appendChild(this.calDepartLabelCont, this.calDepartSpanLabel);

    this.calDepartSpan = this.ren.createElement('span');
    this.ren.setAttribute(this.calDepartSpan, 'class', 'calenderDepartSpan');
    this.ren.addClass(this.calDepartSpan, 'calendar-placeholder');
    if (this.departPlaceHolder) {
      this.calDepartSpan.innerText = this.departPlaceHolder;
    } else {
      this.calDepartSpan.innerText = this.showDateFormat;
    }
    this.ren.setAttribute(this.calDepartSpan, 'aria-hidden', 'true');
    this.ren.appendChild(this.calDepartLabelCont, this.calDepartSpan);

    this.calDepartInput = this.ren.createElement('input');
    this.ren.setAttribute(this.calDepartInput, 'type', 'hidden');
    this.ren.setAttribute(this.calDepartInput, 'aria-hidden', 'true');
    this.ren.setAttribute(
      this.calDepartInput,
      'formControlName',
      'departureDate'
    );

    this.ren.appendChild(this.calDepartLabelCont, this.calDepartInput);

    if (this.defaultDepartDate && this.defaultDepartDate.trim() !== '') {
      this.setDefaultDate(new Date(this.defaultDepartDate));
    } else {
      if (this.showDefaultDate) {
        this.setDefaultDate();
      }
    }

    this.calDateSeparator = this.ren.createElement('span');
    this.ren.setAttribute(
      this.calDateSeparator,
      'class',
      'calDateSeparator icon-line'
    );
    if (this.calDefaultDateSeparator === 'true') {
      this.calDateSeparator.innerText = '-';
    }
    this.ren.appendChild(this.calDisplayCont, this.calDateSeparator);

    this.calReturnLabelCont = this.ren.createElement('span');
    this.ren.setAttribute(
      this.calReturnLabelCont,
      'class',
      'calReturnLabelCont'
    );
    this.ren.setAttribute(this.calReturnLabelCont, 'id', 'calReturnLabelCont');
    this.ren.setAttribute(this.calReturnLabelCont, 'aria-label', 'returnDate');
    this.ren.appendChild(this.calDisplayCont, this.calReturnLabelCont);

    this.calReturnSpanLabel = this.ren.createElement('span');
    this.ren.setAttribute(this.calReturnSpanLabel, 'class', 'sr-only');
    this.calReturnSpanLabel.innerText = this.returnLabel + ' date not selected';
    this.ren.appendChild(this.calReturnLabelCont, this.calReturnSpanLabel);

    this.calReturnSpan = this.ren.createElement('span');
    this.ren.setAttribute(this.calReturnSpan, 'class', 'calenderReturnSpan');
    if (this.returnPlaceHolder) {
      this.calReturnSpan.innerText = this.returnPlaceHolder;
    } else {
      this.calReturnSpan.innerText = this.showDateFormat;
    }
    this.ren.addClass(this.calReturnSpan, 'calendar-placeholder');
    this.ren.setAttribute(this.calReturnSpan, 'aria-hidden', 'true');
    this.ren.appendChild(this.calReturnLabelCont, this.calReturnSpan);

    this.calReturnInput = this.ren.createElement('input');
    this.ren.setAttribute(this.calReturnInput, 'type', 'hidden');
    this.ren.setAttribute(this.calReturnInput, 'aria-hidden', 'true');
    this.ren.appendChild(this.calReturnLabelCont, this.calReturnInput);

    this.ren.setAttribute(this.calReturnInput, 'formControlName', 'returnDate');

    this.calSRDepartReturnCont = this.ren.createElement('div');
    this.ren.setAttribute(
      this.calSRDepartReturnCont,
      'class',
      'calSRDepartReturnCont'
    );
    this.ren.setAttribute(
      this.calSRDepartReturnCont,
      'aria-describedby',
      'calSRDepartReturnLabelCont'
    );
    this.ren.appendChild(this.calendarMasterCont, this.calSRDepartReturnCont);

    this.calSRDepartReturnLabelCont = this.ren.createElement('span');
    this.ren.setAttribute(this.calSRDepartReturnLabelCont, 'class', 'sr-only');
    this.ren.setAttribute(
      this.calSRDepartReturnLabelCont,
      'id',
      'calSRDepartReturnLabelCont'
    );

    this.ren.setAttribute(
      this.calSRDepartReturnLabelCont,
      'aria-live',
      'assertive'
    );
    this.ren.appendChild(
      this.calSRDepartReturnCont,
      this.calSRDepartReturnLabelCont
    );

    this.checkFieldVisibility();

    this.ren.listen(this.el.nativeElement, 'focus', (event) => {
      this.SRInstructionCont.innerText =
        'Use enter to open, escape to close the calendar, page down for next month and page up for previous month';
      this.handleCalVisibility(event);
    });

    this.ren.listen(this.calDisplayCont, 'click', (event) => {
      this.calClick.emit(event);
      this.handleCalVisibility(event);
    });

    // this.ren.listen(this.calDisplayCont, 'focus', (event) => {
    //   if (this.standaloneCal && this.floatingLbl) {
    //     try {
    //       let lblObj = document.getElementById(this.floatingLbl);
    //       if (lblObj) {
    //         lblObj.setAttribute('class', 'floatinglabel');
    //       }
    //       let selectedDate = this.calDisplayCont.children[0].children[1];
    //       if (selectedDate && selectedDate.innerText === this.departPlaceHolder) {
    //         selectedDate.innerText = '';
    //       }
    //     } catch (e) {

    //     }
    //   }
    //   this.calFocus.emit(event);
    // });

    this.ren.listen(this.calDisplayCont, 'blur', (event) => {
      if (this.standaloneCal && this.floatingLbl) {
        try {
          let selectedDate = this.calDisplayCont.children[0].children[2].value;
          if (selectedDate && selectedDate !== '') {
            const lblObj = document.getElementById(this.floatingLbl);
            if (lblObj) {
              lblObj.setAttribute('class', 'floatinglabel');
            }
          } else {
            const lblObj = document.getElementById(this.floatingLbl);
            if (lblObj) {
              lblObj.setAttribute('class', 'floatinglabel invisible');
            }
            selectedDate = this.calDisplayCont.children[0].children[1];
            if (selectedDate) {
              selectedDate.innerText = this.departPlaceHolder;
            }
          }
        } catch (e) {}
      }
      if (this.childEls !== undefined) {
        if (
          event.relatedTarget !== this.calDisplayCont &&
          event.target !== this.calCancelButtonCont &&
          event.target !== this.calCancelButton &&
          event.target !== this.calResetButton &&
          event.target !== this.calFlexDateCheckBox &&
          event.target !== this.calFlexDateCheckBoxLabel &&
          event.target !== this.calCloseButton &&
          event.target !== this.caldonebutton &&
          this.childEls.indexOf(event.relatedTarget) < 0
        ) {
          this.calBlur.emit(event);
        }
      } else {
        this.calBlur.emit(event);
      }
    });

    this.ren.listen(this.calDisplayCont, 'keydown', (event) => {
      if (event.which === 13 || event.keyCode === 13) {
        // ENTER key
        this.calClick.emit(event);
        this.handleCalVisibility(event);
        event.preventDefault();
      }
    });

    this.ren.listen(document, 'click', (event) => {
      if (this.childEls !== undefined) {
        if (
          event.target !== this.calDisplayCont &&
          event.target !== this.calCancelButtonCont &&
          event.target !== this.calCancelButton &&
          event.target !== this.calResetButton &&
          event.target !== this.calCloseButton &&
          event.target !== this.calFlexDateCheckBox &&
          event.target !== this.calFlexDateCheckBoxLabel &&
          event.target !== this.navLinkSpan &&
          event.target !== this.prevNavLinkSpan &&
          event.target !== this.caldonebutton &&
          this.childEls.indexOf(event.target) < 0
        ) {
          if (
            this.calDisplayCont.classList.contains('open') &&
            !(
              event.target.classList.contains('dl-departure') ||
              event.target.classList.contains('dl-return')
            )
          ) {
            this.closeCalendar(event);
          }
        }
      }
    });
  }

  /**
   * Set default date
   */
  setDefaultDate(date: Date = new Date()) {
    this.calDepartSpanLabel.innerText =
      this.departLabel +
      ' selected as ' +
      this.getSRDate(
        date.getDay() + 1,
        date.getDate(),
        date.getMonth() + 1,
        date.getFullYear()
      );
    this.ren.setAttribute(this.calDepartSpan, 'aria-hidden', 'true');
    this.calDepartInput.value = this.getSelectedDate(
      date.getDate(),
      date.getMonth() + 1,
      date.getFullYear(),
      this.dateFormat
    );
    this.ren.removeClass(this.calDepartSpan, 'calendar-placeholder');
    this.calDepartSpan.innerText = this.getSelectedDate(
      date.getDate(),
      date.getMonth() + 1,
      date.getFullYear(),
      this.displayDateFormat
    );
    this.travelDateForm.controls['departureDate'].setValue(
      this.calDepartInput.value
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.defaultDepartDate &&
      !changes.defaultDepartDate.isFirstChange() &&
      this.defaultDepartDate &&
      this.defaultDepartDate !== ''
    ) {
      this.setDefaultDate(new Date(this.defaultDepartDate));
    }
  }

  /** handle calendar visibility
   *
   *
   * @memberof NgcCalendarDirective
   */
  handleCalVisibility(event) {
    if (!this.calDisplayCont.classList.contains('open')) {
      this.openCalendar();
    } else {
      this.closeCalendar(event);
    }
  }

  /** set the attributes
   *
   *
   * @param {Element} eleName
   * @param {string} attrName
   * @param {string} expectedStyle
   * @memberof NgcCalendarDirective
   */
  setInlineStyle(eleName, attrName, expectedStyle) {
    if (
      eleName !== undefined &&
      eleName !== null &&
      attrName !== undefined &&
      attrName !== null &&
      expectedStyle !== undefined &&
      expectedStyle !== null
    ) {
      if (eleName.getAttribute(attrName) !== expectedStyle) {
        this.ren.setAttribute(eleName, attrName, expectedStyle);
      }
    }
  }

  /** Check field Visibility
   *
   *
   * @memberof NgcCalendarDirective
   */
  checkFieldVisibility() {
    if (this.dataTravel === 'roundtrip') {
      this.setInlineStyle(this.calDateSeparator, 'style', 'display:inline');
      this.setInlineStyle(this.calReturnLabelCont, 'style', 'display:inline');
      this.setInlineStyle(this.calReturnSpanLabel, 'style', 'display:inline');
      this.setInlineStyle(this.calReturnSpan, 'style', 'display:inline');
      this.setInlineStyle(this.calReturnInput, 'style', 'display:inline');
      if (this.calReturnSpanLabel.hasAttribute('aria-hidden')) {
        this.ren.removeAttribute(this.calReturnSpanLabel, 'aria-hidden');
      }
      if (this.calDefaultDateSeparator === 'true') {
        this.calDateSeparator.innerText = '-';
      }
    } else {
      this.setInlineStyle(this.calDateSeparator, 'style', 'display:none');
      this.setInlineStyle(this.calReturnLabelCont, 'style', 'display:none');
      this.setInlineStyle(this.calReturnSpanLabel, 'style', 'display:none');
      this.setInlineStyle(this.calReturnSpan, 'style', 'display:none');
      this.setInlineStyle(this.calReturnInput, 'style', 'display:none');
      this.setInlineStyle(this.calReturnLabelCont, 'aria-hidden', 'true');
      this.setInlineStyle(this.calReturnSpanLabel, 'aria-hidden', 'true');
      this.calDateSeparator.innerText = '';
      this.calReturnSpanLabel.innerText = '';
      this.calReturnSpan.innerText = '';
    }
    this.setInlineStyle(this.calDateSeparator, 'aria-hidden', 'true');
    this.setInlineStyle(this.calReturnSpan, 'aria-hidden', 'true');
    this.setInlineStyle(this.calReturnInput, 'aria-hidden', 'true');
    try {
      this.ren.setAttribute(
        this.calDisplayCont,
        'style',
        'width:' +
          this.el.nativeElement.clientWidth +
          'px; height:' +
          this.el.nativeElement.clientHeight +
          'px'
      );
      // const elementLeftPosition = this.el.nativeElement.getBoundingClientRect().left;
      // const calObj = this.el.nativeElement.parentElement.querySelector('.dl-datepicker');
      // let calContainer = this.el.nativeElement.parentElement.querySelector('.calenderContainer');
      // this.ren.listen(calContainer, 'click', (evt) => {
      //   if (evt.target === calContainer) {
      //     this.closeCalendar();
      //   }
      // });
    } catch (e) {}
  }

  /** Display the calendar dialog
   *
   *
   * @memberof NgcCalendarDirective
   */
  openCalendar() {
    this.getCurrentMonth();
    if (isPlatformBrowser(this.platformId) && this.viewportWidth === 0) {
      this.viewportWidth = document.body.scrollWidth;
    }
    this.createCalendar();
    this.ren.addClass(this.calDisplayCont, 'open');
    if (isPlatformBrowser(this.platformId) && this.viewportWidth === 0) {
      this.viewportWidth = document.body.scrollWidth;
    }
    if (this.viewportWidth > 991) {
      try {
        const parentWidget = document.getElementsByClassName(
          'widget-container-lg'
        );
        if (parentWidget && parentWidget.length > 0) {
          const parent = <HTMLElement>parentWidget[0];
          let parentMarginTop = parseInt(parent.style.marginTop);
          if (Number.isNaN(parentMarginTop)) {
            parentMarginTop = 0;
          }
          let childPaddingTop = 0;
          if (window.getComputedStyle) {
            childPaddingTop = parseInt(
              getComputedStyle(this.calendarWrapper).getPropertyValue(
                'padding-top'
              )
            );
          } else if (this.calendarWrapper.currentStyle) {
            childPaddingTop = parseInt(
              this.calendarWrapper.currentStyle['padding-top']
            );
          }
          if (
            !Number.isNaN(childPaddingTop) &&
            parentMarginTop - childPaddingTop > 0
          ) {
            this.ren.setStyle(this.calendarWrapper, 'padding-top', '10px');
            this.ren.setStyle(this.calendarWrapper, 'padding-left', '10px');
            this.ren.setStyle(this.calendarWrapper, 'padding-right', '10px');
          }
        }
      } catch (err) {}
    }
    this.ren.setAttribute(this.calDisplayCont, 'aria-expanded', 'true');
    this.calendarWrapper.focus();
    if (this.viewportWidth > 991 && this.isFirefox()) {
      this.calendarWrapper.scrollIntoView({ block: 'nearest' });
    }
    const mobileClose = document.getElementsByClassName(
      'action-bar-mobile-widget'
    )[0];
    if (mobileClose !== null && mobileClose !== undefined) {
      mobileClose.className += ' hide-action-bar-mobile-widget';
    }
    // to close calendar when click out side of calendar.
    const calContainer =
      this.el.nativeElement.parentElement.querySelector('.calenderContainer');
    if (calContainer) {
      this.ren.listen(calContainer, 'click', (evt) => {
        if (evt.target === calContainer) {
          this.closeCalendar();
        }
      });
    }
  }

  isFirefox() {
    // Checking for firefox browser
    const browserData = window.navigator.userAgent;
    const fireFox = browserData.match(/Firefox/i);
    return fireFox;
  }

  isIE() {
    const browserData = window.navigator.userAgent;
    const ie = browserData.indexOf('Trident/'); // IE 11
    return ie;
  }

  /** Hide the calendar dialog
   *
   *
   * @memberof NgcCalendarDirective
   */
  closeCalendar(event?) {
    this.calClick.emit(event);
    this.tabCounter = 0;
    this.currFocusDate = -7;
    this.ren.removeClass(this.calDisplayCont, 'open');
    this.ren.setAttribute(this.calDisplayCont, 'aria-expanded', 'false');
    if (this.calendarCont.parentNode !== null) {
      this.ren.removeChild(this.calendarCont.parentNode, this.calendarCont);
    }
    this.SRInstructionCont.innerText =
      'Use enter to open, escape to close, page down for next month and page up for previous month';
    this.getCurrentMonth();
    this.calDisplayCont.focus();
    const mobileClose = document.getElementsByClassName(
      'action-bar-mobile-widget'
    )[0];
    if (mobileClose !== null && mobileClose !== undefined) {
      mobileClose.classList.remove('hide-action-bar-mobile-widget');
    }
  }

  /** Create the actual calendar header part
   *
   *
   * @memberof NgcCalendarDirective
   */
  createCalendar() {
    this.calendarCont = this.ren.createElement('div');
    this.ren.setAttribute(this.calendarCont, 'class', 'calenderContainer');

    this.calendarWrapper = this.ren.createElement('div');
    if (this.numberOfMonthsView > 1) {
      this.ren.setAttribute(
        this.calendarWrapper,
        'class',
        'dl-datepicker dl-datepicker-multi dl-datepicker-multi-2'
      );
    } else {
      this.ren.setAttribute(
        this.calendarWrapper,
        'class',
        'dl-datepicker dl-datepicker-multi'
      );
    }

    this.ren.setAttribute(this.calendarWrapper, 'tabindex', '0');
    this.ren.setAttribute(this.calendarWrapper, 'role', 'application');
    this.ren.setAttribute(
      this.calendarWrapper,
      'aria-label',
      'Calendar expanded, use arrow keys to select date'
    );

    this.calPrevNextBtnCont = this.ren.createElement('div');
    this.ren.setAttribute(
      this.calPrevNextBtnCont,
      'class',
      'calPrevNextBtnCont'
    );

    this.calCancelButtonCont = this.ren.createElement('div');
    this.ren.setAttribute(
      this.calCancelButtonCont,
      'class',
      'cancelButtonCont'
    );

    this.calCancelButton = this.ren.createElement('button');
    this.ren.setAttribute(this.calCancelButton, 'type', 'button');
    this.ren.setAttribute(this.calCancelButton, 'value', 'cancel');
    this.ren.setAttribute(this.calCancelButton, 'aria-label', 'cancel');
    this.ren.setAttribute(this.calCancelButton, 'class', 'cancelButton');
    this.calCancelButton.innerText = 'Cancel';

    this.calResetButton = this.ren.createElement('button');
    this.ren.setAttribute(this.calResetButton, 'type', 'button');
    this.ren.setAttribute(this.calResetButton, 'value', 'clear');
    this.ren.setAttribute(this.calResetButton, 'aria-label', 'clear');
    this.ren.setAttribute(this.calResetButton, 'class', 'resetButton');
    this.calResetButton.innerText = 'Clear';

    this.calCloseButtonCont = this.ren.createElement('div');
    this.ren.setAttribute(this.calCloseButtonCont, 'class', 'closeButtonCont');

    this.calCloseButton = this.ren.createElement('button');
    this.ren.setAttribute(this.calCloseButton, 'type', 'button');
    this.ren.setAttribute(this.calCloseButton, 'value', 'close');
    this.ren.setAttribute(this.calCloseButton, 'aria-label', 'close');
    this.ren.setAttribute(
      this.calCloseButton,
      'class',
      'closeButton icon-moreoptionsclose'
    );

    this.calCloseButtonText = this.ren.createElement('span');
    if (this.viewportWidth > 991) {
      this.ren.setAttribute(this.calCloseButtonText, 'class', 'sr-only');
    }

    this.calCloseButtonText.innerText = 'Close';

    this.caldonebuttonCont = this.ren.createElement('div');
    this.ren.setAttribute(this.caldonebuttonCont, 'class', 'donebuttonCont');

    this.caldonebutton = this.ren.createElement('button');
    this.ren.setAttribute(this.caldonebutton, 'type', 'button');
    this.ren.setAttribute(this.caldonebutton, 'value', 'done');
    this.ren.setAttribute(this.caldonebutton, 'aria-label', 'done');
    this.ren.setAttribute(this.caldonebutton, 'class', 'donebutton');
    this.caldonebutton.innerText = 'done';

    this.caldonebuttonText = this.ren.createElement('span');
    if (this.viewportWidth > 991) {
      this.ren.setAttribute(this.caldonebuttonText, 'class', 'sr-only');
    }

    this.caldonebuttonText.innerText = 'done';

    this.calFlexDateCheckBox = this.ren.createElement('input');
    this.ren.setAttribute(this.calFlexDateCheckBox, 'type', 'checkbox');
    this.ren.setAttribute(this.calFlexDateCheckBox, 'value', 'false');
    this.ren.setAttribute(this.calFlexDateCheckBox, 'class', 'chk-flexDate');
    this.ren.setAttribute(this.calFlexDateCheckBox, 'id', 'calFlexDate');
    if (this.isFlexDatesDisabled === 'true') {
      this.ren.setAttribute(this.calFlexDateCheckBox, 'disabled', 'true');
      this.ren.setAttribute(this.calFlexDateCheckBox, 'checked', 'true');
    } else {
      if (this.travelDateForm.controls['chkFlexDate'] !== undefined) {
        if (this.travelDateForm.controls['chkFlexDate'].value === true) {
          this.ren.setAttribute(this.calFlexDateCheckBox, 'checked', 'true');
        }
      }
    }
    if (this.isFlexDatesDisabledByEdoc === 'true') {
      this.ren.setAttribute(this.calFlexDateCheckBox, 'disabled', 'true');
      this.ren.setAttribute(this.calFlexDateCheckBox, 'checked', 'false');
    } else if (this.isFlexDatesDisabledByEdoc === 'false') {
      this.ren.removeAttribute(this.calFlexDateCheckBox, 'disabled');
    }
    this.calFlexDateCheckBoxLabel = this.ren.createElement('label');
    this.ren.setAttribute(this.calFlexDateCheckBoxLabel, 'for', 'calFlexDate');
    if (this.isFlexDatesDisabledByEdoc === 'true') {
      this.ren.setAttribute(
        this.calFlexDateCheckBoxLabel,
        'class',
        'lbl-calFlexDate icon-Checked lbl-calFlexDateDisabled'
      );
    } else {
      this.ren.setAttribute(
        this.calFlexDateCheckBoxLabel,
        'class',
        'lbl-calFlexDate icon-Checked'
      );
    }
    this.ren.setProperty(
      this.calFlexDateCheckBoxLabel,
      'innerHTML',
      'Flexible Dates'
    );
    this.ren.setAttribute(this.calFlexDateCheckBoxLabel, 'tabindex', '0');

    this.calFlexDateCont = this.ren.createElement('div');
    this.ren.setAttribute(
      this.calFlexDateCont,
      'class',
      'calFlexDateCont float-left'
    );

    this.ren.appendChild(this.calFlexDateCont, this.calFlexDateCheckBox);
    this.ren.appendChild(this.calFlexDateCont, this.calFlexDateCheckBoxLabel);
    if (this.viewportWidth <= 800) {
      this.ren.appendChild(this.calCloseButton, this.calCloseButtonText);
    }
    // this.ren.appendChild(this.calCloseButton, this.calCloseButtonText);
    this.ren.appendChild(this.calendarMasterCont, this.calendarCont);
    this.ren.appendChild(this.calendarCont, this.calendarWrapper);
    if (this.viewportWidth <= 800) {
      this.ren.appendChild(this.calendarWrapper, this.calCloseButtonCont);
    }
    // this.ren.appendChild(this.calendarWrapper, this.calCloseButtonCont);

    this.calMobileHeadRow = this.ren.createElement('div');
    this.ren.setAttribute(this.calMobileHeadRow, 'class', 'mobileWeekHeader');

    // adding mobile flexible footer
    this.calMobileFooterRow = this.ren.createElement('div');
    this.ren.setAttribute(
      this.calMobileFooterRow,
      'class',
      'mobileCheckboxFooter'
    );
    if (this.viewportWidth <= 991) {
      // Mobile View Render
      this.ren.appendChild(this.calCloseButtonCont, this.calResetButton);
      if (
        this.config.get('APP_CALENDAR_TABLE_HEADER') === 'true' ||
        this.config.get('CALENDER_TABLE_HEADER') === 'true'
      ) {
        this.createTableForWeekDays(this.weekArray);
      } else {
        for (let i = 0; i < this.weekArray.length; i++) {
          const daySpan = this.ren.createElement('span');
          this.ren.setAttribute(daySpan, 'class', 'weekdays');
          this.ren.setAttribute(daySpan, 'title', this.weekArray[i]);

          if (this.numberOfWeekdayChar !== 'Full') {
            daySpan.innerText = this.weekArray[i].substring(
              0,
              this.numberOfWeekdayChar
            );
          }
          if (
            this.weekArray[i] === 'Sunday' ||
            this.weekArray[i] === 'Saturday'
          ) {
            this.ren.setAttribute(daySpan, 'class', 'dl-datepicker-week-end');
            this.ren.setAttribute(daySpan, 'class', 'dl-datepicker-week-end');
          }
          this.ren.appendChild(this.calMobileHeadRow, daySpan);
        }
      }
      this.ren.appendChild(this.calendarWrapper, this.calMobileHeadRow);
      if (this.isFlexDates === 'true') {
        this.ren.appendChild(this.calMobileFooterRow, this.calFlexDateCheckBox);
        this.ren.appendChild(
          this.calMobileFooterRow,
          this.calFlexDateCheckBoxLabel
        );
      }
      this.ren.appendChild(this.calMobileFooterRow, this.caldonebuttonCont);
      this.ren.appendChild(this.caldonebuttonCont, this.caldonebutton);
      this.calHorizantalRow = this.ren.createElement('div');
      this.ren.setAttribute(
        this.calHorizantalRow,
        'class',
        'mobileHorizantalbar'
      );
    }
    this.ren.appendChild(this.calCloseButtonCont, this.calCloseButton);

    this.ren.appendChild(this.calendarWrapper, this.calPrevNextBtnCont);

    this.calendarGroupWrapper = this.ren.createElement('div');
    this.ren.setAttribute(
      this.calendarGroupWrapper,
      'class',
      'dl-datepicker-group-wrapper'
    );

    this.ren.appendChild(this.calendarWrapper, this.calendarGroupWrapper);
    // create calendar month view
    for (let i = 0; i < this.numberOfMonthsView; i++) {
      this.createCalendarBody(i);
      this.ren.addClass(this.calendarGroup, 'dl-datepicker-group-' + i);
    }

    // create and set value for previous and next button
    for (let j = 0; j < 2; j++) {
      this.createPrevNextBtn(this.calPrevNextBtnCont);
      if (j === 0) {
        if (
          this.currMonthIndex < this.currCalMonthIndex &&
          this.currYear === this.presentCalYear
        ) {
          this.ren.setAttribute(
            this.navLink,
            'class',
            'dl-datepicker-' + j + ' no-previous'
          );
          this.ren.setAttribute(
            this.navLink,
            'title',
            'Previous month not available'
          );
          this.prevNavLinkSpan = this.navLinkSpan;
        } else {
          this.ren.setAttribute(this.navLink, 'class', 'dl-datepicker-' + j);
          this.ren.setAttribute(
            this.navLink,
            'title',
            'To select previous month'
          );
          this.SRInstructionCont.innerText = '';
        }
      } else {
        if (
          this.currMonthIndex <= this.last_month - 1 &&
          this.currYear <= this.last_year &&
          this.currMonthIndex >= this.last_month - 1 &&
          this.currYear === this.last_year
        ) {
          this.ren.setAttribute(
            this.navLink,
            'class',
            'dl-datepicker-' + j + ' no-next'
          );
          this.ren.setAttribute(
            this.navLink,
            'title',
            'Next month not available'
          );
        } else {
          if (this.currMonthIndex !== this.last_month) {
            this.ren.setAttribute(this.navLink, 'class', 'dl-datepicker-' + j);
            this.ren.setAttribute(
              this.navLink,
              'title',
              'To select next month'
            );
            this.SRInstructionCont.innerText = '';
          } else {
            this.ren.setAttribute(
              this.navLink,
              'class',
              'dl-datepicker-' + j + ' no-next'
            );
            this.ren.setAttribute(
              this.navLink,
              'title',
              'Next month not available'
            );
          }
        }
      }
    }

    if (this.viewportWidth > 991) {
      this.ren.appendChild(this.calendarWrapper, this.calCancelButtonCont);
    }
    if (this.isFlexDates === 'true') {
      this.ren.appendChild(this.calCancelButtonCont, this.calFlexDateCont);
      if (
        this.calHorizantalRow !== undefined &&
        this.calHorizantalRow !== null
      ) {
        this.ren.appendChild(this.calendarWrapper, this.calHorizantalRow);
      }
      this.ren.appendChild(this.calendarWrapper, this.calMobileFooterRow);
      this.ren.removeClass(this.calCancelButtonCont, 'cancelButtonAlignItem');
    } else {
      this.ren.appendChild(this.calMobileFooterRow, this.caldonebuttonCont);
      this.ren.appendChild(this.calendarWrapper, this.calMobileFooterRow);
      this.ren.addClass(this.calCancelButtonCont, 'cancelButtonAlignItem');
    }

    if (this.viewportWidth > 991) {
      this.ren.appendChild(this.calCancelButtonCont, this.calResetButton);
      this.ren.appendChild(this.calCancelButtonCont, this.caldonebutton);
      const multiCityEl = document.getElementById('selectTripType-val');
      const flightStatusEl = this.el.nativeElement.getAttribute('id');
      if (
        multiCityEl !== undefined &&
        multiCityEl !== null &&
        multiCityEl.textContent === 'Multi-City'
      ) {
        const multiCalendarCancel =
          document.getElementsByClassName('resetButton')[0];
        if (
          multiCalendarCancel !== undefined &&
          multiCalendarCancel !== null &&
          this.isFlexDates === 'true'
        ) {
          multiCalendarCancel.classList.add('multiCancelButton');
        }
        const multiCalContainer =
          document.getElementsByClassName('calenderContainer')[0];
        if (multiCalContainer !== undefined && multiCalContainer !== null) {
          multiCalContainer.classList.add('multiCalendarContainer');
        }
      }
      if (
        flightStatusEl !== undefined &&
        flightStatusEl !== null &&
        flightStatusEl === 'searchBydate'
      ) {
        const flightCalendarCancel =
          document.getElementsByClassName('resetButton')[0];
        if (
          flightCalendarCancel !== undefined &&
          flightCalendarCancel !== null &&
          this.isFlexDates === 'true'
        ) {
          flightCalendarCancel.classList.add('multiCancelButton');
        }
        const flightCalContainer =
          document.getElementsByClassName('calenderContainer')[0];
        if (flightCalContainer !== undefined && flightCalContainer !== null) {
          flightCalContainer.classList.add('flightCalendarContainer');
        }
      }
    }
    this.getFocusableElement(this.calendarWrapper);

    this.getDayLinkElement(this.calendarCont);
    this.ren.listen(this.calendarWrapper, 'keydown', (event) => {
      this.getFocusableDateElement(this.calendarWrapper);
      const Dialog = this;
      const KEY_TAB = 9;
      const KEY_ESC = 27;
      const KEY_UP = 38;
      const KEY_DOWN = 40;
      const KEY_LEFT = 37;
      const KEY_RIGHT = 39;
      const KEY_PGUP = 33;
      const KEY_PGDOWN = 34;
      const KEY_HOME = 36;
      const KEY_END = 35;

      switch (event.keyCode || event.which) {
        case KEY_ESC: {
          this.closeCalendar(event);
          event.preventDefault();
          break;
        }
        case KEY_TAB: {
          if (Dialog.focusableEls.length === 1) {
            Dialog.firstFocusableEl.focus();
            event.preventDefault();
          } else if (Dialog.focusableEls.length === 0) {
            event.preventDefault();
          }
          if (event.shiftKey) {
            Dialog.handleBackwardTab(event);
          } else {
            Dialog.handleForwardTab(event);
          }
          break;
        }
        case KEY_UP: {
          Dialog.handleUPKey(event);
          event.preventDefault();
          break;
        }
        case KEY_DOWN: {
          Dialog.handleDOWNKey(event);
          event.preventDefault();
          break;
        }
        case KEY_LEFT: {
          Dialog.handleLEFTKey(event);
          event.preventDefault();
          break;
        }
        case KEY_RIGHT: {
          Dialog.handleRIGHTKey(event);
          event.preventDefault();
          break;
        }
        case KEY_PGUP: {
          Dialog.handlePGUPKey(event);
          event.preventDefault();
          break;
        }
        case KEY_PGDOWN: {
          Dialog.handlePGDOWNKey(event);
          event.preventDefault();
          break;
        }
        case KEY_HOME: {
          Dialog.handleHOMEKey(event);
          event.preventDefault();
          break;
        }
        case KEY_END: {
          Dialog.handleENDKey(event);
          event.preventDefault();
          break;
        }
        default: {
          break;
        }
      } // end switch
    });

    this.calendarWrapper
      .querySelector('.dl-datepicker-1')
      .setAttribute('aria-label', 'Next');
    this.calendarWrapper.querySelector('.dl-datepicker-1 span').innerText =
      'Next';

    this.ren.listen(this.calCancelButton, 'click', (event) => {
      this.cancelNResetCalendar();
      this.closeCalendar(event);
    });

    this.ren.listen(this.calCloseButton, 'click', (event) => {
      this.closeCalendar(event);
    });

    this.ren.listen(this.caldonebutton, 'click', (event) => {
      this.closeCalendar(event);
    });

    this.ren.listen(this.calResetButton, 'click', (event) => {
      this.resetViewCalendar();
    });
    this.ren.listen(this.calFlexDateCheckBox, 'click', (event) => {
      this.setFlexDate(event);
    });
  }

  createTableForWeekDays(weekArray: any) {
    this.calTable = this.ren.createElement('table');
    this.ren.setAttribute(this.calMobileHeadRow, 'role', 'presentation');
    this.ren.appendChild(this.calMobileHeadRow, this.calTable);
    const calTableBodyWeek = this.ren.createElement('tbody');
    const calTableBodyRowWeek = this.ren.createElement('tr');
    this.ren.appendChild(this.calTable, calTableBodyWeek);
    this.ren.appendChild(calTableBodyWeek, calTableBodyRowWeek);
    for (let i = 0; i < weekArray.length; i++) {
      const daySpan = this.ren.createElement('span');
      this.ren.setAttribute(daySpan, 'class', 'weekdays');
      this.ren.setAttribute(daySpan, 'title', weekArray[i]);
      const calTD = this.ren.createElement('td');
      if (this.numberOfWeekdayChar !== 'Full') {
        daySpan.innerText = weekArray[i].substring(0, this.numberOfWeekdayChar);
      }
      if (weekArray[i] === 'Sunday' || weekArray[i] === 'Saturday') {
        this.ren.setAttribute(calTD, 'class', 'dl-datepicker-week-end');
        this.ren.setAttribute(daySpan, 'class', 'dl-datepicker-week-end');
      }
      this.ren.appendChild(calTableBodyRowWeek, calTD);
      this.ren.appendChild(calTD, daySpan);
    }
  }

  /** create the previous and next button
   *
   *
   * @param {any} btnCont
   * @memberof NgcCalendarDirective
   */
  createPrevNextBtn(btnCont) {
    this.navLink = this.ren.createElement('a');
    this.ren.setAttribute(this.navLink, 'aria-label', 'Previous');
    this.ren.setAttribute(
      this.navLink,
      'title',
      'Previous month not available'
    );
    this.ren.setAttribute(this.navLink, 'href', 'javascript:void(0)');
    this.ren.appendChild(btnCont, this.navLink);
    this.SRInstructionCont.innerText = 'No Previous month available';

    /** Sets the Preveious and Next Button Functionality */
    this.ren.listen(this.navLink, 'click', (event) => {
      this.setMonthEvent(event);
    });

    this.ren.listen(this.navLink, 'keydown', (event) => {
      const KEY_ENTER = 13;
      switch (event.keyCode || event.which) {
        case KEY_ENTER: {
          this.setMonthEvent(event);
          event.preventDefault();
          break;
        }
        default: {
          break;
        }
      }
    });

    this.navLinkSpan = this.ren.createElement('span');
    this.ren.setAttribute(this.navLinkSpan, 'class', 'monthSelector');
    this.navLinkSpan.innerText = 'Prev';
    this.ren.appendChild(this.navLink, this.navLinkSpan);
  }

  /** create the main body of the calendar to display the date
   *
   *
   * @param {any} currMonthIndex
   * @memberof NgcCalendarDirective
   */
  createCalendarBody(currMonthIndex) {
    this.calendarGroup = this.ren.createElement('div');
    this.ren.setAttribute(this.calendarGroup, 'class', 'dl-datepicker-group');
    this.ren.appendChild(this.calendarGroupWrapper, this.calendarGroup);

    const calendarHeader = this.ren.createElement('div');
    this.ren.setAttribute(calendarHeader, 'class', 'dl-datepicker-header');
    this.ren.appendChild(this.calendarGroup, calendarHeader);

    const calTitle = this.ren.createElement('div');
    this.ren.setAttribute(calTitle, 'class', 'dl-datepicker-title');
    this.ren.appendChild(calendarHeader, calTitle);

    this.calMonth = this.ren.createElement('span');
    this.ren.setAttribute(
      this.calMonth,
      'class',
      'dl-datepicker-month-' + currMonthIndex
    );
    this.ren.appendChild(calTitle, this.calMonth);

    this.calYear = this.ren.createElement('span');
    this.ren.setAttribute(
      this.calYear,
      'class',
      'dl-datepicker-year dl-datepicker-year-' + currMonthIndex
    );
    this.calYear.innerText = this.currYear;
    this.ren.appendChild(calTitle, this.calYear);

    this.calTableCont = this.ren.createElement('div');
    this.ren.setAttribute(
      this.calTableCont,
      'class',
      'dl-datepicker-calendar-cont'
    );

    this.ren.appendChild(this.calendarGroup, this.calTableCont);

    this.calTable = this.ren.createElement('table');
    this.ren.setAttribute(this.calTable, 'class', 'dl-datepicker-calendar');
    this.ren.setAttribute(this.calTable, 'role', 'presentation');
    this.ren.appendChild(this.calTableCont, this.calTable);

    const calTableHead = this.ren.createElement('thead');
    if (this.viewportWidth > 991) {
      //  || (this.viewportWidth < 991 && currMonthIndex === 0)
      this.ren.appendChild(this.calTable, calTableHead);
    }

    const calTableHeadRow = this.ren.createElement('tr');
    this.ren.appendChild(calTableHead, calTableHeadRow);

    this.calTableBody = this.ren.createElement('tbody');
    this.ren.setAttribute(
      this.calTableBody,
      'class',
      'dl-datepicker-tbody-' + currMonthIndex
    );
    this.ren.appendChild(this.calTable, this.calTableBody);

    for (let i = 0; i < this.weekArray.length; i++) {
      const calTH = this.ren.createElement('th');
      this.ren.setAttribute(calTH, 'scope', 'col');

      const daySpan = this.ren.createElement('span');
      this.ren.setAttribute(daySpan, 'class', 'weekdays');
      this.ren.setAttribute(daySpan, 'title', this.weekArray[i]);

      const calTD = this.ren.createElement('td');

      if (this.numberOfWeekdayChar !== 'Full') {
        daySpan.innerText = this.weekArray[i].substring(
          0,
          this.numberOfWeekdayChar
        );
      }
      if (this.weekArray[i] === 'Sunday' || this.weekArray[i] === 'Saturday') {
        this.ren.setAttribute(calTH, 'class', 'dl-datepicker-week-end');
        this.ren.setAttribute(calTD, 'class', 'dl-datepicker-week-end');
      }
      this.ren.appendChild(calTH, daySpan);
      this.ren.appendChild(calTableHeadRow, calTH);
    }

    if (
      this.travelDateForm.controls['departureDate'].value === '' ||
      this.numberOfMonthsView > 2
    ) {
      let startMonth = new Date().getMonth();
      let showYearNumber = this.currYear;
      let showMonthName = this.getMonthName(startMonth + currMonthIndex);

      const monthIndex = startMonth + currMonthIndex;
      if (monthIndex > 11) {
        const currMonth = monthIndex - 12;
        showMonthName = this.getMonthName(currMonth);
        currMonthIndex = currMonth;
        startMonth = 0;
        showYearNumber += 1;
      }

      this.calMonth.innerText = showMonthName;
      this.calYear.innerText = showYearNumber;
      this.calTableBody.innerHTML = this.setCalendarMonth(
        showYearNumber,
        startMonth,
        currMonthIndex
      );
      this.currMonthIndex = this.now.getMonth();
      this.getCalChildElement(this.calendarMasterCont);
    } else {
      let departDate = this.travelDateForm.controls['departureDate'].value;
      let currDepartDate;
      currDepartDate = departDate.split('-');
      if (currDepartDate.length > 1) {
        departDate = new Date(
          currDepartDate[1] + '/' + currDepartDate[2] + '/' + currDepartDate[0]
        );
      } else {
        departDate = new Date(
          this.travelDateForm.controls['departureDate'].value
        );
      }
      const departMonth = departDate.getMonth();
      const departYear = departDate.getFullYear();
      this.currYear = departYear;
      this.setMonthView(departMonth);
      this.currMonthIndex = departMonth;
    }
  }

  /** Get The focusable element inside the calendar control
   *
   *
   * @param {any} activeModalComp
   * @memberof NgcCalendarDirective
   */
  getFocusableElement(activeModalComp) {
    this.focusableEls =
      activeModalComp.querySelectorAll(`a[class="dl-datepicker-0"],
    a[class="dl-datepicker-1"],
    a[class="dl-datepicker-0 no-previous"],
    a[class="dl-datepicker-1 no-next"],
    button:not([disabled]),
    [tabindex="0"]`);
    this.focusableEls = Array.prototype.slice.call(this.focusableEls);
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
  }

  /** Get The focusable element inside the calendar control
   *
   *
   * @param {any} activeModalComp
   * @memberof NgcCalendarDirective
   */
  getFocusableDateElement(activeModalComp) {
    this.focusableDateEls =
      activeModalComp.querySelectorAll(`a.dl-state-default,
    a[class="dl-state-default dl-selected-date dl-departure"],
    a[class="dl-state-default dl-selected-date dl-return"],
    a[class="dl-state-default dl-selected-date dl-departreturn"]`);
    this.focusableDateEls = Array.prototype.slice.call(this.focusableDateEls);
    this.firstFocusableDateEl = this.focusableDateEls[0];
    this.lastFocusableDateEl =
      this.focusableDateEls[this.focusableDateEls.length - 1];
    const getCurrentEvent = this;
    this.timeouts.push(
      setTimeout(() => {
        const lastFocusElement =
          getCurrentEvent.focusableDateEls[getCurrentEvent.currFocusDate];
        if (
          lastFocusElement !== undefined &&
          lastFocusElement.classList !== undefined &&
          lastFocusElement.classList.contains('dl-return')
        ) {
          lastFocusElement.focus();
        }
      }, 100)
    );
  }

  /** Get The focusable element inside the calendar control
   *
   *
   * @param {any} activeComp
   * @memberof NgcCalendarDirective
   */
  getCalChildElement(activeComp) {
    this.childEls = activeComp.querySelectorAll(`div,
    div.cancelButtonCont,
    a[href],
    a,
    span,
    table,
    thead,
    tbody,
    tr,
    th,
    td`);
    this.childEls = Array.prototype.slice.call(this.childEls);
  }

  /**
   *
   *
   * @param {any} activeComp
   * @memberof NgcCalendarDirective
   */
  getDayLinkElement(activeComp) {
    this.dayLinkEls = activeComp.querySelectorAll('a.dl-state-default');
    this.dayLinkEls = Array.prototype.slice.call(this.dayLinkEls);
    for (let i = 0; i <= this.dayLinkEls.length; i++) {
      if (this.dayLinkEls[i] !== undefined) {
        this.ren.listen(this.dayLinkEls[i], 'click', (event) => {
          this.setCalendarDate(event);
        });
        this.ren.listen(this.dayLinkEls[i], 'keydown', (event) => {
          if (event.which === 13 || event.keyCode === 13) {
            // ENTER key
            event.preventDefault();
            event.target.click();
            // this.setCalendarDate(event);
          }
        });
        // this.ren.listen(this.dayLinkEls[i], 'mouseover', (event) => {
        //   this.checkSwapDate(event);
        // });
      }
    }
  }

  /**
   *
   *
   * @param {any} evt
   * @memberof NgcCalendarDirective
   */
  setCalendarDate(evt) {
    if (this.dataTravel === 'roundtrip') {
      if (this.clickCounter >= 2) {
        this.resetCalendar();
      } else {
        this.clickCounter++;
      }
    } else {
      if (
        this.el.nativeElement !== undefined &&
        this.el.nativeElement.getAttribute('id') !== 'departureDate1' &&
        this.clickCounter === 0
      ) {
        this.clickCounter = 1;
      }
      if (this.clickCounter >= 1) {
        this.resetCalendar();
      } else {
        this.clickCounter++;
      }
    }
    this.ren.addClass(evt.target, 'dl-selected-date');

    let selectedDate = evt.target.dataset.date;
    if (selectedDate !== undefined) {
      selectedDate = selectedDate.split('|');
    }
    if (this.dataTravel !== 'roundtrip') {
      this.ren.addClass(evt.target, 'dl-departure');
      if (this.displayDateFormat && selectedDate[0]) {
        const dateArray = selectedDate[0].split('/');
        const departDD = dateArray[1];
        const departMM = dateArray[0];
        const departYY = dateArray[2];
        this.calDepartSpan.innerText = this.getSelectedDate(
          departDD,
          departMM,
          departYY,
          this.displayDateFormat
        );
      } else {
        this.calDepartSpan.innerText = selectedDate[1];
      }
      this.ren.removeClass(this.calDepartSpan, 'calendar-placeholder');
      this.calDepartSpanLabel.innerText =
        this.departLabel + ' selected as ' + selectedDate[2];
      this.SRInstructionCont.innerText =
        this.departLabel + ' selected as ' + selectedDate[2];
      this.ren.setAttribute(this.calDepartSpan, 'aria-hidden', 'true');
      this.calDepartInput.value = selectedDate[0];
      this.travelDateForm.controls['departureDate'].setValue(selectedDate[0]);
      if (this.returnPlaceHolder) {
        this.calReturnSpan.innerText = this.returnPlaceHolder;
      } else {
        this.calReturnSpan.innerText = this.showDateFormat;
      }
      this.ren.addClass(this.calReturnSpan, 'calendar-placeholder');
      this.calReturnSpanLabel.innerText =
        this.returnLabel + ' date not selected';
      this.ren.setAttribute(this.calReturnSpan, 'aria-hidden', 'true');
      this.calReturnInput.value = '';
      if (this.travelDateForm.controls['returnDate'] !== undefined) {
        this.travelDateForm.controls['returnDate'].setValue('');
      }
      // this.closeCalendar(evt);
    } else {
      if (
        (!this.departPlaceHolder &&
          !this.returnPlaceHolder &&
          this.calDepartSpan.innerText === this.showDateFormat &&
          this.calReturnSpan.innerText === this.showDateFormat) ||
        (this.calDepartSpan.innerText === this.departPlaceHolder &&
          this.calReturnSpan.innerText === this.returnPlaceHolder)
      ) {
        this.ren.addClass(evt.target, 'dl-departure');
        this.calDepartSpan.innerText = selectedDate[1];
        this.ren.removeClass(this.calDepartSpan, 'calendar-placeholder');
        this.calDepartSpanLabel.innerText =
          this.departLabel + ' selected as ' + selectedDate[2];
        this.SRInstructionCont.innerText =
          this.departLabel + ' selected as ' + selectedDate[2];
        this.ren.setAttribute(this.calDepartSpan, 'aria-hidden', 'true');
        this.calDepartInput.value = selectedDate[0];
        this.travelDateForm.controls['departureDate'].setValue(selectedDate[0]);
        this.ren.setAttribute(
          this.calDisplayCont,
          'id',
          'input_returnDate_' + this.index
        );
      } else if (
        (!this.departPlaceHolder &&
          !this.returnPlaceHolder &&
          this.calDepartSpan.innerText !== this.showDateFormat &&
          this.calReturnSpan.innerText !== this.showDateFormat) ||
        (this.calDepartSpan.innerText !== this.departPlaceHolder &&
          this.calReturnSpan.innerText !== this.returnPlaceHolder)
      ) {
        this.ren.addClass(evt.target, 'dl-departure');
        this.calDepartSpan.innerText = selectedDate[1];
        this.ren.removeClass(this.calDepartSpan, 'calendar-placeholder');
        this.calDepartSpanLabel.innerText =
          this.departLabel + ' selected as' + selectedDate[2];
        this.SRInstructionCont.innerText =
          this.departLabel + ' selected as ' + selectedDate[2];
        this.ren.setAttribute(this.calDepartSpan, 'aria-hidden', 'true');
        this.calDepartInput.value = selectedDate[0];
        this.travelDateForm.controls['departureDate'].setValue(selectedDate[0]);
        this.travelDateForm.controls['returnDate'].setValue('');
        this.calReturnSpan.innerText = this.showDateFormat;
        this.ren.addClass(this.calReturnSpan, 'calendar-placeholder');
        this.calReturnInput.value = '';
      } else {
        this.ren.setAttribute(this.calDepartSpanLabel, 'aria-hidden', 'true');

        if (new Date(selectedDate[0]) < new Date(this.calDepartInput.value)) {
          let returnDate, returnDD, returnWD, returnMM, returnYY, SRReturnDate;
          if (
            this.calDepartInput.value !== null &&
            this.calDepartInput.value !== undefined &&
            this.calDepartInput.value !== ''
          ) {
            returnDate = new Date(this.calDepartInput.value);
            returnDD = returnDate.getDate();
            returnWD = returnDate.getDay() + 1;
            returnMM = returnDate.getMonth() + 1;
            returnYY = returnDate.getFullYear();
            SRReturnDate = this.getSRDate(
              returnWD,
              returnDD,
              returnMM,
              returnYY
            );
          }

          // this.ren.addClass(this.calendarCont.querySelector('.dl-departure'), 'dl-return');
          this.ren.addClass(evt.target, 'dl-departure');
          this.calReturnSpan.innerText = this.calDepartSpan.innerText;
          this.ren.removeClass(this.calReturnSpan, 'calendar-placeholder');
          this.calReturnSpanLabel.innerText =
            this.returnLabel + ' date not selected';
          this.ren.removeAttribute(this.calReturnSpan, 'aria-hidden');
          this.calReturnInput.value = this.calDepartInput.value;
          this.travelDateForm.controls['returnDate'].setValue(
            this.calDepartInput.value
          );

          this.calDepartSpan.innerText = selectedDate[1];
          this.ren.removeClass(this.calDepartSpan, 'calendar-placeholder');
          this.calDepartSpanLabel.innerText =
            this.departLabel + ' selected as ' + selectedDate[2];
          this.SRInstructionCont.innerText =
            this.departLabel + ' selected as ' + selectedDate[2];
          this.calSRDepartReturnLabelCont.innerText =
            this.departLabel +
            ' selected as ' +
            selectedDate[2] +
            ' and ' +
            this.returnLabel +
            ' selected as ' +
            SRReturnDate;
          this.ren.setAttribute(this.calDepartSpan, 'aria-hidden', 'true');
          this.calDepartInput.value = selectedDate[0];
          this.travelDateForm.controls['departureDate'].setValue(
            selectedDate[0]
          );
        } else {
          let departDate, departDD, departWD, departMM, departYY, SRDepartDate;
          if (
            this.travelDateForm.controls['departureDate'].value !== null &&
            this.travelDateForm.controls['departureDate'].value !== undefined &&
            this.travelDateForm.controls['departureDate'].value !== ''
          ) {
            departDate = new Date(
              this.travelDateForm.controls['departureDate'].value
            );
            departDD = departDate.getDate();
            departWD = departDate.getDay() + 1;
            departMM = departDate.getMonth() + 1;
            departYY = departDate.getFullYear();
            SRDepartDate = this.getSRDate(
              departWD,
              departDD,
              departMM,
              departYY
            );
          }

          this.ren.addClass(evt.target, 'dl-return');
          this.calReturnSpan.innerText = selectedDate[1];
          this.ren.removeClass(this.calReturnSpan, 'calendar-placeholder');
          this.calReturnSpanLabel.innerText =
            this.returnLabel + ' date not selected';
          this.ren.removeAttribute(this.calReturnSpan, 'aria-hidden');
          this.calReturnInput.value = selectedDate[0];
          this.travelDateForm.controls['returnDate'].setValue(selectedDate[0]);
          this.calSRDepartReturnLabelCont.innerText =
            this.departLabel +
            ' selected as ' +
            SRDepartDate +
            ' and ' +
            this.returnLabel +
            ' selected as ' +
            selectedDate[2];
        }
        // this.closeCalendar(evt);
        setTimeout(() => {
          this.ren.setAttribute(
            this.calDepartSpanLabel,
            'aria-hidden',
            'false'
          );
        }, 1000);
      }

      this.currDepartDate = this.calDepartSpan.innerText;
      this.currDepartValue = this.calDepartInput.value;
      this.currReturnDate = this.calReturnSpan.innerText;
      this.currReturnValue = this.calReturnInput.value;
      if (
        this.currDepartValue !== null &&
        this.currDepartValue !== undefined &&
        this.currDepartValue !== '' &&
        this.currReturnValue !== null &&
        this.currReturnValue !== undefined &&
        this.currReturnValue !== ''
      ) {
        this.setMonthView(this.currMonthIndex);
        this.getDayLinkElement(this.calendarCont);
      }
      // this.SRInstructionCont.innerText = "Departure Date selected as " + selectedDate[1];
    }
  }

  /** handle date swap feature
   *
   *
   * @param {any} evt
   * @memberof NgcCalendarDirective
   */
  checkSwapDate(evt) {
    if (this.dataTravel === 'roundtrip') {
      if (this.currDepartValue !== '' && this.currReturnValue === '') {
        let selectedDate = evt.target.dataset.date;
        if (selectedDate !== undefined) {
          selectedDate = selectedDate.split('|');
        }
        if (new Date(selectedDate[0]) < new Date(this.currDepartValue)) {
          this.calReturnSpan.innerText = this.currDepartDate;
          this.ren.removeClass(this.calReturnSpan, 'calendar-placeholder');
          this.calReturnSpanLabel.innerText =
            this.returnLabel + ' date not selected';
          this.ren.setAttribute(this.calReturnSpan, 'aria-hidden', 'true');
          this.calReturnInput.value = this.currDepartValue;
          this.travelDateForm.controls['returnDate'].setValue(
            this.currDepartValue
          );

          this.calDepartSpan.innerText = selectedDate[1];
          this.ren.removeClass(this.calDepartSpan, 'calendar-placeholder');
          this.calDepartSpanLabel.innerText =
            this.departLabel + ' selected as ' + selectedDate[2];
          this.SRInstructionCont.innerText =
            this.departLabel + ' selected as ' + selectedDate[2];
          this.ren.setAttribute(this.calDepartSpan, 'aria-hidden', 'true');
          this.calDepartInput.value = selectedDate[0];
          this.travelDateForm.controls['departureDate'].setValue(
            selectedDate[0]
          );
        } else {
          this.calDepartSpan.innerText = this.currDepartDate;
          this.ren.removeClass(this.calDepartSpan, 'calendar-placeholder');
          this.calDepartSpanLabel.innerText =
            this.departLabel + ' selected as ' + selectedDate[2];
          this.SRInstructionCont.innerText =
            this.departLabel + ' selected as ' + selectedDate[2];
          this.ren.setAttribute(this.calDepartSpan, 'aria-hidden', 'true');
          this.calDepartInput.value = this.currDepartValue;
          this.travelDateForm.controls['departureDate'].setValue(
            this.currDepartValue
          );

          this.calReturnSpan.innerText = selectedDate[1];
          this.ren.removeClass(this.calReturnSpan, 'calendar-placeholder');
          this.calReturnSpanLabel.innerText =
            this.returnLabel + ' date not selected';
          this.ren.setAttribute(this.calReturnSpan, 'aria-hidden', 'true');
          this.calReturnInput.value = selectedDate[0];
          this.travelDateForm.controls['returnDate'].setValue(selectedDate[0]);
        }
      }
    }
  }

  /** Handle forward TAB on the calendar control
   *
   *
   * @param {any} event
   * @memberof NgcCalendarDirective
   */
  handleBackwardTab(event) {
    event.preventDefault();
    this.currFocusDate = -7;
    if (this.tabCounter <= 1) {
      this.focusableEls[this.focusableEls.length - 1].focus();
      this.tabCounter = this.focusableEls.length;
    } else {
      this.tabCounter--;
      this.focusableEls[this.tabCounter - 1].focus();
    }
  }

  /** Handle backward TAB on the calendar control
   *
   *
   * @param {any} event
   * @memberof NgcCalendarDirective
   */
  handleForwardTab(event) {
    this.currFocusDate = -7;
    event.preventDefault();
    const setFlexDate = event.target.classList.contains('dl-return');
    if (this.tabCounter === this.focusableEls.length) {
      if (this.focusableEls[0].classList.contains('no-previous')) {
        this.focusableEls[1].focus();
        this.tabCounter = 2;
      } else {
        this.focusableEls[0].focus();
        this.tabCounter = 1;
      }
    } else if (setFlexDate) {
      this.focusableEls[2].focus();
      this.tabCounter = 3;
    } else {
      if (
        this.focusableEls[this.tabCounter].classList.contains('no-previous')
      ) {
        this.tabCounter++;
      }
      this.focusableEls[this.tabCounter].focus();
      this.tabCounter++;
    }
  }

  /** handle UP key on the calendar control
   *
   *
   * @param {any} event
   * @memberof NgcCalendarDirective
   */
  handleUPKey(event) {
    if (this.currFocusDate === -7) {
      this.currFocusDate = 7;
    }
    if (this.currFocusDate - 7 < 0) {
      // return;
      this.setPrevMonth();
      this.getFocusableDateElement(this.calendarWrapper);
      const currMonthLength = this.getMonthLength(event.target.dataset.date);
      this.currFocusDate = this.focusableDateEls.length - 1 - currMonthLength;
      if (this.focusableDateEls[this.currFocusDate] !== undefined) {
        this.focusableDateEls[this.currFocusDate].focus();
      }
    } else {
      this.currFocusDate -= 7;
      if (this.focusableDateEls[this.currFocusDate] !== undefined) {
        this.focusableDateEls[this.currFocusDate].focus();
      }
    }
  }

  /**
   *
   *
   * @param {any} event
   * @memberof NgcCalendarDirective
   */
  handleDOWNKey(event) {
    if (this.currFocusDate + 7 >= this.focusableDateEls.length) {
      // return;
      if (this.currMonthIndex < this.last_month - 1) {
        this.setNextMonth();
        this.getFocusableDateElement(this.calendarWrapper);
        const currMonthLength = this.getMonthLength(event.target.dataset.date);
        this.currFocusDate = currMonthLength;
        if (this.focusableDateEls[this.currFocusDate] !== undefined) {
          this.focusableDateEls[this.currFocusDate].focus();
        }
      }
    } else {
      this.currFocusDate += 7;
      if (this.focusableDateEls[this.currFocusDate] !== undefined) {
        this.focusableDateEls[this.currFocusDate].focus();
      }
    }
  }

  /**
   *
   *
   * @param {any} event
   * @memberof NgcCalendarDirective
   */
  handleLEFTKey(event) {
    if (this.currFocusDate === -7) {
      this.currFocusDate = 1;
    }
    if (this.currFocusDate - 1 < 0) {
      // return;
      this.setPrevMonth();
      this.getFocusableDateElement(this.calendarWrapper);
      const currMonthLength = this.getMonthLength(event.target.dataset.date);
      this.currFocusDate = this.focusableDateEls.length - 1 - currMonthLength;
      this.focusableDateEls[this.currFocusDate].focus();
    } else {
      this.currFocusDate -= 1;
      if (this.focusableDateEls[this.currFocusDate] !== undefined) {
        this.focusableDateEls[this.currFocusDate].focus();
      }
    }
  }

  /**
   *
   *
   * @param {any} event
   * @memberof NgcCalendarDirective
   */
  handleRIGHTKey(event) {
    if (this.currFocusDate === -7) {
      this.currFocusDate = -1;
    }
    if (this.currFocusDate + 1 >= this.focusableDateEls.length) {
      // return;
      if (
        this.currMonthIndex !== this.last_month - 1 &&
        this.currMonthIndex !== this.last_month &&
        this.currYear <= this.last_year
      ) {
        this.setNextMonth();
        this.getFocusableDateElement(this.calendarWrapper);
        const currMonthLength = this.getMonthLength(event.target.dataset.date);
        this.currFocusDate = currMonthLength;
        this.focusableDateEls[this.currFocusDate].focus();
      }
    } else {
      this.currFocusDate += 1;
      if (this.focusableDateEls[this.currFocusDate] !== undefined) {
        this.focusableDateEls[this.currFocusDate].focus();
      }
    }
  }

  /**
   *
   *
   * @param {any} event
   * @memberof NgcCalendarDirective
   */
  handlePGUPKey(event) {
    this.calendarWrapper.focus();
    this.setPrevMonth();
  }

  /**
   *
   *
   * @param {any} event
   * @memberof NgcCalendarDirective
   */
  handlePGDOWNKey(event) {
    this.calendarWrapper.focus();
    this.setNextMonth();
  }

  /**
   *
   *
   * @param {any} event
   * @memberof NgcCalendarDirective
   */
  handleHOMEKey(event) {}

  /**
   *
   *
   * @param {any} event
   * @memberof NgcCalendarDirective
   */
  handleENDKey(event) {}

  /** calculate month length
   *
   *
   * @param {any} date
   * @returns
   * @memberof NgcCalendarDirective
   */
  getMonthLength(date) {
    let focusedDate = date;
    focusedDate = focusedDate.split('|');
    focusedDate = focusedDate[0].split('/');
    const focusedMonth = focusedDate[0];
    const focusedYear = focusedDate[2];
    const focusedMonthLength = new Date(focusedYear, focusedMonth, 0).getDate();
    return focusedMonthLength;
  }

  /** handle previous and next button event
   *
   *
   * @param {any} evt
   * @memberof NgcCalendarDirective
   */
  setMonthEvent(evt) {
    if (
      (evt.target !== undefined &&
        evt.target.innerText === 'Prev' &&
        evt.target.parentElement.classList.length < 2) ||
      (evt.target.children[0] !== undefined &&
        evt.target.children[0].innerText === 'Prev' &&
        evt.target.classList.length < 2)
    ) {
      this.setPrevMonth();
    } else if (
      (evt.target !== undefined &&
        evt.target.innerText === 'Next' &&
        evt.target.parentElement.classList.length < 2) ||
      (evt.target.children[0] !== undefined &&
        evt.target.children[0].innerText === 'Next' &&
        evt.target.classList.length < 2)
    ) {
      this.setNextMonth();
    }
  }

  /** set previous Month
   *
   *
   * @memberof NgcCalendarDirective
   */
  setPrevMonth() {
    this.currFocusDate = -7;
    if (this.currMonthIndex >= this.currCalMonthIndex) {
      for (let i = 0; i < this.numberOfMonthsView; i++) {
        this.calendarCont.querySelector('.dl-datepicker-tbody-' + i).innerHTML =
          '';
      }
    }
    if (this.currMonthIndex < this.last_month) {
      this.ren.removeClass(
        this.calendarCont.querySelector('.dl-datepicker-1'),
        'no-next'
      );
      this.calendarCont
        .querySelector('.dl-datepicker-1')
        .setAttribute('title', 'To select next month');
    }
    if (this.currYear <= this.presentCalYear) {
      if (this.currMonthIndex >= this.currCalMonthIndex) {
        this.currMonthIndex--;
        this.setMonthView(this.currMonthIndex);
        this.getDayLinkElement(this.calendarCont);
        if (this.currMonthIndex < this.currCalMonthIndex) {
          this.ren.addClass(
            this.calendarCont.querySelector('.dl-datepicker-0'),
            'no-previous'
          );
          this.calendarCont
            .querySelector('.dl-datepicker-0')
            .setAttribute('title', 'Previous month not available');
          this.SRInstructionCont.innerText += ', No Previous month available';
        }
      } else {
        this.SRInstructionCont.innerText = 'No Previous month available';
      }
    } else {
      this.currMonthIndex--;
      this.setMonthView(this.currMonthIndex);
      this.getDayLinkElement(this.calendarCont);
      if (
        this.currMonthIndex < this.currCalMonthIndex &&
        this.currYear === this.presentCalYear
      ) {
        this.ren.addClass(
          this.calendarCont.querySelector('.dl-datepicker-0'),
          'no-previous'
        );
        this.calendarCont
          .querySelector('.dl-datepicker-0')
          .setAttribute('title', 'Previous month not available');
        this.SRInstructionCont.innerText += ', No Previous month available';
      }
    }
  }

  /** set next month
   *
   *
   * @memberof NgcCalendarDirective
   */
  setNextMonth() {
    this.currFocusDate = -7;
    if (this.currMonthIndex >= this.currCalMonthIndex) {
      for (let i = 0; i < this.numberOfMonthsView; i++) {
        this.calendarCont.querySelector('.dl-datepicker-tbody-' + i).innerHTML =
          '';
      }
    }
    if (this.currMonthIndex <= this.currCalMonthIndex) {
      this.ren.removeClass(
        this.calendarCont.querySelector('.dl-datepicker-0'),
        'no-previous'
      );
      this.calendarCont
        .querySelector('.dl-datepicker-0')
        .setAttribute('title', 'To select previous month');
    }
    if (this.currYear === this.last_year) {
      if (this.currMonthIndex < this.last_month - 1) {
        this.currMonthIndex++;
        this.setMonthView(this.currMonthIndex);
        this.getDayLinkElement(this.calendarCont);
        if (this.currMonthIndex === this.last_month - 1) {
          this.ren.addClass(
            this.calendarCont.querySelector('.dl-datepicker-1'),
            'no-next'
          );
          this.calendarCont
            .querySelector('.dl-datepicker-1')
            .setAttribute('title', 'Next month not available');
          this.SRInstructionCont.innerText += ', No Next month available';
        }
      } else {
        this.SRInstructionCont.innerText += ', No Next month available';
      }
    } else if (this.currYear < this.last_year) {
      this.currMonthIndex++;
      this.setMonthView(this.currMonthIndex);
      this.getDayLinkElement(this.calendarCont);
    }
  }

  /** set the month view based on prev or next button hit
   *
   *
   * @param {any} startMonth
   * @memberof NgcCalendarDirective
   */
  setMonthView(startMonth) {
    let isYearChanged = false;
    let nextMonth = startMonth;
    if (startMonth < 0) {
      nextMonth = 11;
      this.currMonthIndex = 11;
      this.currYear = this.currYear - 1;
    } else if (startMonth > 11) {
      nextMonth = 0;
      this.currMonthIndex = 0;
      this.currYear = this.currYear + 1;
    }
    for (let i = 0; i < this.numberOfMonthsView; i++) {
      // this.calMonth.innerText = this.getMonthName(new Date().getMonth() + startMonth);
      let showMonthName = this.getMonthName(nextMonth);
      let showYearNumber = this.currYear;
      if (isYearChanged) {
        showYearNumber = showYearNumber + 1;
        showMonthName = this.getMonthName(nextMonth + 1);
        nextMonth++;
      }
      if (nextMonth === 0) {
        // This is the condition when calender is in desktop view
        if (startMonth < 11 && startMonth !== 0) {
          showMonthName = this.getMonthName(nextMonth + 1);
          nextMonth++;
        }
      }
      if (showMonthName === undefined) {
        showYearNumber = showYearNumber + 1;
        isYearChanged = true;
        showMonthName = 'January';
        nextMonth = 0;
        startMonth = -1;
      }
      if (
        this.calendarCont.querySelector('.dl-datepicker-month-' + i) !== null &&
        this.calendarCont.querySelector('.dl-datepicker-year-' + i) !== null &&
        this.calendarCont.querySelector('.dl-datepicker-tbody-' + i) !== null
      ) {
        this.calendarCont.querySelector('.dl-datepicker-month-' + i).innerText =
          showMonthName;
        this.calendarCont.querySelector('.dl-datepicker-year-' + i).innerText =
          showYearNumber;
        this.calendarCont.querySelector('.dl-datepicker-tbody-' + i).innerHTML =
          this.setCalendarMonth(showYearNumber, nextMonth, 0);
        if (!isYearChanged) {
          nextMonth++;
        }
        this.getCalChildElement(this.calendarMasterCont);
      }
    }
    this.SRInstructionCont.innerText =
      'Showing Calendar for ' +
      this.calendarCont.querySelector('.dl-datepicker-month-0').innerText +
      ' ' +
      this.calendarCont.querySelector('.dl-datepicker-year-0').innerText;

    if (this.calendarCont.querySelector('.dl-datepicker-month-1') !== null) {
      this.SRInstructionCont.innerText +=
        ' to ' +
        this.calendarCont.querySelector('.dl-datepicker-month-1').innerText +
        ' ' +
        this.calendarCont.querySelector('.dl-datepicker-year-1').innerText;
    }
    this.SRInstructionCont.innerText += ', use arrow keys to select dates';
  }

  /** create the actual calendar dates
   *
   *
   * @param {any} currYear
   * @param {any} monthNumber
   * @param {any} currMonthIndex
   * @returns
   * @memberof NgcCalendarDirective
   */
  setCalendarMonth(currYear, monthNumber, currMonthIndex) {
    const first_day = new Date(currYear, monthNumber + currMonthIndex, 1),
      first_day_weekday = first_day.getDay();

    const month_length = new Date(
        currYear,
        monthNumber + 1 + currMonthIndex,
        0
      ).getDate(),
      previous_month_length = new Date(
        currYear,
        monthNumber + currMonthIndex,
        0
      ).getDate();

    this.last_date = this.getMaxDate();
    this.last_day = this.last_date.getDate();
    this.last_month = this.last_date.getMonth();
    this.last_month_name = this.getMonthName(this.last_date.getMonth());
    this.last_year = this.last_date.getFullYear();

    // calendar content
    // define default day variables
    let day = 1, // current month days
      prev = 1, // previous month days
      next = 1; // next month days

    let html = '<tr class="week">';
    html = this.createEmptyWeekRow(html, true);
    // weeks loop (rows)
    for (let i = 0; i < 9; i++) {
      // weekdays loop (cells)
      for (let j = 1; j <= 7; j++) {
        if (day <= month_length && (i > 0 || j > first_day_weekday)) {
          // current month
          const calDate = this.getSelectedDate(
            day,
            monthNumber + 1 + currMonthIndex,
            currYear,
            this.dateFormat
          );
          const selectorDate = this.setDisplayDate(
            j,
            monthNumber + 1 + currMonthIndex,
            day
          );
          const SRDate = this.getSRDate(
            j,
            day,
            monthNumber + 1 + currMonthIndex,
            currYear
          );
          if (
            (this.calDepartInput.value !== undefined &&
              this.calDepartInput.value !== '') ||
            (this.calReturnInput.value !== undefined &&
              this.calReturnInput.value !== '')
          ) {
            if (calDate === this.today) {
              if (
                calDate === this.calDepartInput.value &&
                calDate !== this.calReturnInput.value
              ) {
                html +=
                  '<td align="center" class="dl-datepicker-current-day days-between days-between-start"><a aria-label="' +
                  SRDate +
                  '" data-date="' +
                  calDate +
                  '|' +
                  selectorDate +
                  '|' +
                  SRDate +
                  '" class="dl-state-default dl-selected-date dl-departure dl-current-day" href="javascript:void(0);">';
              } else if (
                calDate === this.calReturnInput.value &&
                calDate !== this.calDepartInput.value &&
                this.dataTravel === 'roundtrip'
              ) {
                html +=
                  '<td align="center" class="dl-datepicker-current-day days-between days-between-end"><a aria-label="' +
                  SRDate +
                  '" data-date="' +
                  calDate +
                  '|' +
                  selectorDate +
                  '|' +
                  SRDate +
                  '" class="dl-state-default dl-selected-date dl-return dl-current-day" href="javascript:void(0);">';
              } else if (
                calDate === this.calDepartInput.value &&
                calDate === this.calReturnInput.value &&
                this.dataTravel === 'roundtrip'
              ) {
                html +=
                  '<td align="center" class="dl-datepicker-current-day"><a aria-label="' +
                  SRDate +
                  '" data-date="' +
                  calDate +
                  '|' +
                  selectorDate +
                  '|' +
                  SRDate +
                  '" class="dl-state-default dl-selected-date dl-departreturn dl-current-day" href="javascript:void(0);">';
              } else if (
                calDate === this.calDepartInput.value &&
                calDate === this.calReturnInput.value &&
                this.dataTravel !== 'roundtrip'
              ) {
                html +=
                  '<td align="center" class="dl-datepicker-current-day"><a aria-label="' +
                  SRDate +
                  '" data-date="' +
                  calDate +
                  '|' +
                  selectorDate +
                  '|' +
                  SRDate +
                  '" class="dl-state-default dl-selected-date dl-departure dl-current-day" href="javascript:void(0);">';
              } else {
                html +=
                  '<td align="center" class="dl-datepicker-current-day"><a aria-label="' +
                  SRDate +
                  '" data-date="' +
                  calDate +
                  '|' +
                  selectorDate +
                  '|' +
                  SRDate +
                  '" class="dl-state-default" href="javascript:void(0);">';
              }
            } else {
              if (
                calDate === this.calDepartInput.value &&
                calDate !== this.calReturnInput.value
              ) {
                html +=
                  '<td align="center" class="dl-datepicker-available-day days-between days-between-start"><a aria-label="' +
                  SRDate +
                  '" data-date="' +
                  calDate +
                  '|' +
                  selectorDate +
                  '|' +
                  SRDate +
                  '" class="dl-state-default dl-selected-date dl-departure" href="javascript:void(0);">';
              } else if (
                calDate === this.calReturnInput.value &&
                calDate !== this.calDepartInput.value &&
                this.dataTravel === 'roundtrip'
              ) {
                html +=
                  '<td align="center" class="dl-datepicker-available-day days-between days-between-end"><a aria-label="' +
                  SRDate +
                  '" data-date="' +
                  calDate +
                  '|' +
                  selectorDate +
                  '|' +
                  SRDate +
                  '" class="dl-state-default dl-selected-date dl-return" href="javascript:void(0);">';
              } else if (
                calDate === this.calDepartInput.value &&
                calDate === this.calReturnInput.value &&
                this.dataTravel === 'roundtrip'
              ) {
                html +=
                  '<td align="center" class="dl-datepicker-available-day"><a aria-label="' +
                  SRDate +
                  '" data-date="' +
                  calDate +
                  '|' +
                  selectorDate +
                  '|' +
                  SRDate +
                  '" class="dl-state-default dl-selected-date dl-departreturn" href="javascript:void(0);">';
              } else if (
                calDate === this.calDepartInput.value &&
                calDate === this.calReturnInput.value &&
                this.dataTravel !== 'roundtrip'
              ) {
                html +=
                  '<td align="center" class="dl-datepicker-available-day"><a aria-label="' +
                  SRDate +
                  '" data-date="' +
                  calDate +
                  '|' +
                  selectorDate +
                  '|' +
                  SRDate +
                  '" class="dl-state-default dl-selected-date dl-departure" href="javascript:void(0);">';
              } else if (
                new Date(calDate) > new Date(this.calDepartInput.value) &&
                new Date(calDate) < new Date(this.calReturnInput.value) &&
                this.dataTravel === 'roundtrip'
              ) {
                html +=
                  '<td align="center" class="dl-datepicker-available-day days-between"><a aria-label="' +
                  SRDate +
                  '" data-date="' +
                  calDate +
                  '|' +
                  selectorDate +
                  '|' +
                  SRDate +
                  '" class="dl-state-default" href="javascript:void(0);">';
              } else if (new Date(calDate) < this.previous_allowDay) {
                html +=
                  '<td align="center" class="dl-datepicker-previous-day"><span data-date="' +
                  calDate +
                  '|' +
                  selectorDate +
                  '" class="dl-state-disabled">';
              } else if (new Date(calDate) > new Date(this.last_date)) {
                html +=
                  '<td align="center" class="dl-datepicker-next-day"><span data-date="' +
                  calDate +
                  '|' +
                  selectorDate +
                  '" class="dl-state-disabled">';
              } else {
                html +=
                  '<td align="center" class="dl-datepicker-available-day"><a aria-label="' +
                  SRDate +
                  '" data-date="' +
                  calDate +
                  '|' +
                  selectorDate +
                  '|' +
                  SRDate +
                  '" class="dl-state-default" href="javascript:void(0);">';
              }
            }
          } else {
            if (calDate === this.today) {
              html +=
                '<td align="center" class="dl-datepicker-current-day"><a aria-label="' +
                SRDate +
                '" data-date="' +
                calDate +
                '|' +
                selectorDate +
                '|' +
                SRDate +
                '" class="dl-state-default" href="javascript:void(0);">';
            } else if (new Date(calDate) < this.previous_allowDay) {
              html +=
                '<td align="center" class="dl-datepicker-previous-day"><span data-date="' +
                calDate +
                '|' +
                selectorDate +
                '|' +
                SRDate +
                '" class="dl-state-disabled">';
            } else if (new Date(calDate) > new Date(this.last_date)) {
              html +=
                '<td align="center" class="dl-datepicker-next-day"><span data-date="' +
                calDate +
                '|' +
                selectorDate +
                '|' +
                SRDate +
                '" class="dl-state-disabled">';
            } else {
              html +=
                '<td align="center" class="dl-datepicker-available-day"><a aria-label="' +
                SRDate +
                '" data-date="' +
                calDate +
                '|' +
                selectorDate +
                '|' +
                SRDate +
                '" class="dl-state-default" href="javascript:void(0);">';
            }
          }

          // html += '<span aria-hidden="true">' + day + '</span>';
          html += day;
          html += '</a></td>';
          day++;
        } else {
          if (day <= month_length) {
            // previous month
            html +=
              '<td align="center" class="dl-datepicker-other-month dl-datepicker-unselectable dl-state-disabled" aria-hidden="true">';
            // html += previous_month_length - first_day_weekday + prev + 1;
            html += '';
            html += '</td>';
            prev++;
          } else {
            // next month
            html +=
              '<td align="center" class="dl-datepicker-other-month dl-datepicker-unselectable dl-state-disabled" aria-hidden="true">';
            // html += next;
            html += '';
            html += '</td>';
            next++;
          }
        }
      }

      // stop making rows if it's the end of month
      if (day > month_length) {
        html += '</tr>';
        break;
      } else {
        html += '</tr><tr class="week">';
      }
    }
    html = this.createEmptyWeekRow(html, false);
    return html;
  }

  /** create empty first & last row
   * @param {any} html
   * @param {boolean} addRow
   * @returns
   * @memberOf NgcCalendarDirective
   */
  createEmptyWeekRow(html, addRow) {
    for (let j = 0; j < 7; j++) {
      html +=
        '<td align="center" class="dl-datepicker-other-month dl-datepicker-unselectable dl-state-disabled p-0" aria-hidden="true">';
      html += '';
      html += '</td>';
    }
    if (addRow) {
      html += '</tr><tr class="week">';
    } else {
      html += '</tr>';
    }
    return html;
  }

  /** get the date format in the defined format or default format
   *
   *
   * @param {any} dd
   * @param {any} mm
   * @param {any} yyyy
   * @param {any} format
   * @returns
   * @memberof NgcCalendarDirective
   */
  getSelectedDate(dd, mm, yyyy, format) {
    if (format === undefined) {
      format = this.dateFormat;
    }
    if (dd.toString().length < 2) {
      dd = '0' + dd;
    }
    if (mm.toString().length < 2) {
      mm = '0' + mm;
    }
    if (format === 'dd/mm/yyyy') {
      this.selectedDate = dd + '/' + mm + '/' + yyyy;
    }
    switch (format) {
      case 'dd/mm/yyyy': {
        this.selectedDate = dd + '/' + mm + '/' + yyyy;
        break;
      }
      case 'mm/dd/yyyy': {
        this.selectedDate = mm + '/' + dd + '/' + yyyy;
        break;
      }
      case 'yyyy-dd-mm': {
        this.selectedDate = yyyy + '-' + dd + '-' + mm;
        break;
      }
      case 'mm/dd': {
        this.selectedDate = mm + '/' + dd;
        break;
      }
      case 'dddd/mmmm/dd': {
        const day = new Date(mm + '/' + dd + '/' + yyyy);
        const dayName = this.weekArray[day.getDay()];
        const month = this.getMonthName(day.getMonth());
        this.selectedDate = dayName + ', ' + month + ' ' + parseInt(dd);
        break;
      }
      case 'eee/mmm/dd': {
        const day = new Date(mm + '/' + dd + '/' + yyyy);
        const dayName = this.weekArray[day.getDay()];
        const month = this.getMonthName(day.getMonth());
        this.selectedDate =
          dayName.substring(0, 3) +
          ', ' +
          month.substring(0, 3) +
          ' ' +
          parseInt(dd);
        break;
      }
      case 'Mmm/dd': {
        const day = new Date(mm + '/' + dd + '/' + yyyy);
        const month = this.getMonthName(day.getMonth());
        this.selectedDate = month.substring(0, 3) + ' ' + parseInt(dd);
        break;
      }
      default: {
        break;
      }
    }
    return this.selectedDate;
  }

  /**
   *
   *
   * @param {any} wd
   * @param {any} dd
   * @param {any} mm
   * @param {any} yyyy
   * @returns
   * @memberof NgcCalendarDirective
   */
  getSRDate(wd, dd, mm, yyyy) {
    let weekday = this.getWeekName(wd - 1);
    if (weekday !== undefined) {
      weekday = weekday;
    }
    let month = this.getMonthName(mm - 1);
    if (month !== undefined) {
      month = month;
    }
    const SRDate = dd + ' ' + month + ' ' + yyyy + ', ' + weekday;
    return SRDate;
  }

  /** set how the dates displayed in the datepicker input box
   *
   *
   * @param {any} wd
   * @param {any} mm
   * @param {any} dd
   * @returns
   * @memberof NgcCalendarDirective
   */
  setDisplayDate(wd, mm, dd) {
    let weekday = this.getWeekName(wd - 1);
    if (weekday !== undefined) {
      weekday = weekday.substring(0, this.numberOfWeekdayChar);
    }
    let month = this.getMonthName(mm - 1);
    if (month !== undefined) {
      if (month !== 'Full') {
        month = month.substring(0, this.numberOfMonthChar);
      }
    }
    const displayDate = weekday + ', ' + month + ' ' + dd;
    return displayDate;
  }

  /** get max date till whihc the caledar dates will be populated */
  /**
   *
   *
   * @param {any} [allowday]
   * @returns
   * @memberof NgcCalendarDirective
   */
  getMaxDate(allowday?) {
    if (allowday === undefined) {
      allowday = this.allowDay;
    }
    const oneDay = 24 * 60 * 60 * 1000;
    const maxDay = new Date(this.now.getTime() + oneDay * allowday);
    return maxDay;
  }

  /** reset the calendar display and values */
  /**
   *
   *
   * @memberof NgcCalendarDirective
   */
  resetCalendar() {
    this.selectedDates = this.calendarWrapper
      .querySelectorAll(`a[href].dl-selected-date,
    a.dl-selected-date`);
    this.selectedDates = Array.prototype.slice.call(this.selectedDates);

    this.selectedDatesBetween =
      this.calendarWrapper.querySelectorAll('td.days-between');
    this.selectedDatesBetween = Array.prototype.slice.call(
      this.selectedDatesBetween
    );
    for (let i = 0; i < this.selectedDates.length; i++) {
      this.ren.removeClass(this.selectedDates[i], 'dl-selected-date');
    }
    for (let i = 0; i < this.selectedDatesBetween.length; i++) {
      this.ren.removeClass(this.selectedDatesBetween[i], 'days-between');
    }
    this.clickCounter = 1;
  }

  /**
   *
   *
   * @memberof NgcCalendarDirective
   */
  resetViewCalendar() {
    this.clickCounter = 2;
    // this.currFocusDate = -7;
    this.selectedDates = this.calendarWrapper
      .querySelectorAll(`a[href].dl-selected-date,
    a.dl-selected-date`);
    this.selectedDates = Array.prototype.slice.call(this.selectedDates);

    this.selectedDatesBetween =
      this.calendarWrapper.querySelectorAll('td.days-between');
    this.selectedDatesBetween = Array.prototype.slice.call(
      this.selectedDatesBetween
    );
    for (let i = 0; i < this.selectedDates.length; i++) {
      this.ren.removeClass(this.selectedDates[i], 'dl-selected-date');
      this.ren.removeClass(this.selectedDates[i], 'dl-departreturn');
    }
    for (let i = 0; i < this.selectedDatesBetween.length; i++) {
      this.ren.removeClass(this.selectedDatesBetween[i], 'days-between');
    }
    if (this.departPlaceHolder) {
      this.calDepartSpan.innerText = this.departPlaceHolder;
    } else {
      this.calDepartSpan.innerText = this.showDateFormat;
    }
    this.ren.addClass(this.calDepartSpan, 'calendar-placeholder');
    this.calDepartSpanLabel.innerText = this.departLabel + ' date not selected';
    this.ren.setAttribute(this.calDepartSpan, 'aria-hidden', 'true');
    this.calDepartInput.value = '';
    this.travelDateForm.controls['departureDate'].setValue('');
    if (this.returnPlaceHolder) {
      this.calReturnSpan.innerText = this.returnPlaceHolder;
    } else {
      this.calReturnSpan.innerText = this.showDateFormat;
    }
    this.ren.addClass(this.calReturnSpan, 'calendar-placeholder');
    this.calReturnSpanLabel.innerText = this.returnLabel + ' date not selected';
    this.ren.setAttribute(this.calReturnSpan, 'aria-hidden', 'true');
    this.SRInstructionCont.innerText =
      'Calendar reset with no date selection, use arrow keys to select date';
    this.calReturnInput.value = '';
    if (this.travelDateForm.controls['returnDate']) {
      this.travelDateForm.controls['returnDate'].setValue('');
    }
    this.calendarWrapper.focus();
    this.getFocusableDateElement(this.calendarWrapper);
  }

  /**
   *
   *
   * @memberof NgcCalendarDirective
   */
  cancelNResetCalendar() {
    if (
      (this.travelDateForm.controls['departureDate'].value === '' ||
        this.travelDateForm.controls['returnDate'].value === '') &&
      this.dataTravel === 'roundtrip'
    ) {
      this.selectedDates = this.calendarWrapper
        .querySelectorAll(`a[href].dl-selected-date,
      a.dl-selected-date`);
      this.selectedDates = Array.prototype.slice.call(this.selectedDates);

      this.selectedDatesBetween =
        this.calendarWrapper.querySelectorAll('td.days-between');
      this.selectedDatesBetween = Array.prototype.slice.call(
        this.selectedDatesBetween
      );
      for (let i = 0; i < this.selectedDates.length; i++) {
        this.ren.removeClass(this.selectedDates[i], 'dl-selected-date');
      }
      for (let i = 0; i < this.selectedDatesBetween.length; i++) {
        this.ren.removeClass(this.selectedDatesBetween[i], 'days-between');
      }
      if (this.departPlaceHolder) {
        this.calDepartSpan.innerText = this.departPlaceHolder;
      } else {
        this.calDepartSpan.innerText = this.showDateFormat;
      }
      this.ren.addClass(this.calDepartSpan, 'calendar-placeholder');
      this.calDepartSpanLabel.innerText =
        this.departLabel + ' date not selected';
      this.ren.setAttribute(this.calDepartSpan, 'aria-hidden', 'true');
      this.calDepartInput.value = '';
      this.travelDateForm.controls['departureDate'].setValue('');
      if (this.returnPlaceHolder) {
        this.calReturnSpan.innerText = this.returnPlaceHolder;
      } else {
        this.calReturnSpan.innerText = this.showDateFormat;
      }
      this.ren.addClass(this.calReturnSpan, 'calendar-placeholder');
      this.calReturnSpanLabel.innerText =
        this.returnLabel + ' date not selected';
      this.ren.setAttribute(this.calReturnSpan, 'aria-hidden', 'true');
      this.calReturnInput.value = '';
      this.travelDateForm.controls['returnDate'].setValue('');
      this.clickCounter = 2;
    }
  }

  getDisplayDateInFormat(date, format) {
    if (format && date) {
      const newDate = new Date(date);
      const departDD = newDate.getDate();
      const departMM = newDate.getMonth() + 1;
      const departYY = newDate.getFullYear();
      return this.getSelectedDate(departDD, departMM, departYY, format);
    } else {
      return date;
    }
  }

  setFlexDate(event) {
    if (this.calFlexDateCheckBox.checked === true) {
      this.travelDateForm.controls['chkFlexDate'].setValue(true);
    } else {
      this.travelDateForm.controls['chkFlexDate'].setValue(false);
    }
  }

  stopTimeout() {
    for (let i = 0; i < this.timeouts.length; i++) {
      clearTimeout(this.timeouts[i]);
    }
    this.timeouts = [];
  }

  ngOnDestroy() {
    this.stopTimeout();
  }
}
